/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CommunityGuidelinesRouteImport } from './routes/community-guidelines'
import { Route as HelpRouteImport } from './routes/help'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as PublicLandingRouteImport } from './routes/_public/_landing'
import { Route as PublicJoinACircleRouteImport } from './routes/_public/join-a-circle'
import { Route as PublicStartACircleRouteImport } from './routes/_public/start-a-circle'
import { Route as AuthFinishingRouteImport } from './routes/auth/finishing'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthPasswordResetRouteImport } from './routes/auth/password-reset'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSsoCallbackRouteImport } from './routes/auth/sso-callback'
import { Route as InvitesTokenRouteImport } from './routes/invites/$token'
import { Route as OnboardingBuildSkillsRouteImport } from './routes/onboarding/build-skills'
import { Route as OnboardingCirclesRouteImport } from './routes/onboarding/circles'
import { Route as OnboardingCompleteRouteImport } from './routes/onboarding/complete'
import { Route as OnboardingGetInvolvedRouteImport } from './routes/onboarding/get-involved'
import { Route as OnboardingProfileRouteImport } from './routes/onboarding/profile'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding/welcome'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedCirclesNewRouteImport } from './routes/_authed/circles/new'
import { Route as AuthedCoachIndexRouteImport } from './routes/_authed/coach/index'
import { Route as AuthedDirectoryIndexRouteImport } from './routes/_authed/directory/index'
import { Route as AuthedEventsIndexRouteImport } from './routes/_authed/events/index'
import { Route as AuthedFeedIndexRouteImport } from './routes/_authed/feed/index'
import { Route as AuthedGroupsIndexRouteImport } from './routes/_authed/groups/index'
import { Route as AuthedGroupsNewRouteImport } from './routes/_authed/groups/new'
import { Route as AuthedInvitationsIndexRouteImport } from './routes/_authed/invitations/index'
import { Route as AuthedMembersIdRouteImport } from './routes/_authed/members/$id'
import { Route as AuthedMessagesIndexRouteImport } from './routes/_authed/messages/index'
import { Route as AuthedNetworksCreateRouteImport } from './routes/_authed/networks/create'
import { Route as AuthedNetworksNewRouteImport } from './routes/_authed/networks/new'
import { Route as AuthedNotificationsIndexRouteImport } from './routes/_authed/notifications/index'
import { Route as AuthedPeopleIndexRouteImport } from './routes/_authed/people/index'
import { Route as AuthedPostsIdRouteImport } from './routes/_authed/posts/$id'
import { Route as AuthedProfileIndexRouteImport } from './routes/_authed/profile/index'
import { Route as AuthedProfileMeRouteImport } from './routes/_authed/profile/me'
import { Route as AuthedRoadmapIndexRouteImport } from './routes/_authed/roadmap/index'
import { Route as AuthedSearchIndexRouteImport } from './routes/_authed/search/index'
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed/settings/index'
import { Route as PublicLandingGetStartedRouteImport } from './routes/_public/_landing/get-started'
import { Route as PublicLandingJoinUsRouteImport } from './routes/_public/_landing/join-us'
import { Route as PublicLandingSignInRouteImport } from './routes/_public/_landing/sign-in'
import { Route as PublicCirclesIndexRouteImport } from './routes/_public/circles/index'
import { Route as PublicJoinANetworkIndexRouteImport } from './routes/_public/join-a-network/index'
import { Route as PublicJoinANetworkSlugRouteImport } from './routes/_public/join-a-network/$slug'
import { Route as PublicJoinIndexRouteImport } from './routes/_public/join/index'
import { Route as PublicJoinSlugRouteImport } from './routes/_public/join/$slug'
import { Route as PublicNetworksIndexRouteImport } from './routes/_public/networks/index'
import { Route as PublicResourcesIndexRouteImport } from './routes/_public/resources/index'
import { Route as OnboardingClCompleteRouteImport } from './routes/onboarding/cl/complete'
import { Route as OnboardingClCreateCircleRouteImport } from './routes/onboarding/cl/create-circle'
import { Route as OnboardingClWelcomeRouteImport } from './routes/onboarding/cl/welcome'
import { Route as OnboardingCmBuildSkillsRouteImport } from './routes/onboarding/cm/build-skills'
import { Route as OnboardingCmCompleteRouteImport } from './routes/onboarding/cm/complete'
import { Route as OnboardingCmConnectRouteImport } from './routes/onboarding/cm/connect'
import { Route as OnboardingCmFindCircleRouteImport } from './routes/onboarding/cm/find-circle'
import { Route as OnboardingCmWelcomeRouteImport } from './routes/onboarding/cm/welcome'
import { Route as OnboardingJAboutRouteImport } from './routes/onboarding/j/about'
import { Route as OnboardingJCircleRouteImport } from './routes/onboarding/j/circle'
import { Route as OnboardingJYoureInRouteImport } from './routes/onboarding/j/youre-in'
import { Route as OnboardingNlAccessNetworkRouteImport } from './routes/onboarding/nl/access-network'
import { Route as OnboardingNlCompleteRouteImport } from './routes/onboarding/nl/complete'
import { Route as OnboardingNlHubRouteImport } from './routes/onboarding/nl/hub'
import { Route as OnboardingNlManageNetworkRouteImport } from './routes/onboarding/nl/manage-network'
import { Route as OnboardingNlNetworkPageRouteImport } from './routes/onboarding/nl/network-page'
import { Route as OnboardingNlWelcomeRouteImport } from './routes/onboarding/nl/welcome'
import { Route as AuthedAdminBroadcastsIndexRouteImport } from './routes/_authed/admin/broadcasts/index'
import { Route as AuthedAdminCoachIndexRouteImport } from './routes/_authed/admin/coach/index'
import { Route as AuthedAdminDsrIndexRouteImport } from './routes/_authed/admin/dsr/index'
import { Route as AuthedAdminFeatureFlagsIndexRouteImport } from './routes/_authed/admin/feature-flags/index'
import { Route as AuthedAdminInvitationsIndexRouteImport } from './routes/_authed/admin/invitations/index'
import { Route as AuthedAdminMembersIndexRouteImport } from './routes/_authed/admin/members/index'
import { Route as AuthedAdminMembersUserIdRouteImport } from './routes/_authed/admin/members/$userId'
import { Route as AuthedAdminModerationIndexRouteImport } from './routes/_authed/admin/moderation/index'
import { Route as AuthedAdminModerationReportIdRouteImport } from './routes/_authed/admin/moderation/$reportId'
import { Route as AuthedAdminResourcesIndexRouteImport } from './routes/_authed/admin/resources/index'
import { Route as AuthedAdminRoadmapIndexRouteImport } from './routes/_authed/admin/roadmap/index'
import { Route as AuthedAdminRoadmapItemIdRouteImport } from './routes/_authed/admin/roadmap/$itemId'
import { Route as AuthedAdminTopicsIndexRouteImport } from './routes/_authed/admin/topics/index'
import { Route as AuthedAdminTopicsTopicIdRouteImport } from './routes/_authed/admin/topics/$topicId'
import { Route as AuthedAdminUserResearchIndexRouteImport } from './routes/_authed/admin/user-research/index'
import { Route as AuthedCirclesIdAdminRouteImport } from './routes/_authed/circles/$id/admin'
import { Route as AuthedCirclesIdEditRouteImport } from './routes/_authed/circles/$id/edit'
import { Route as AuthedEventsIdIndexRouteImport } from './routes/_authed/events/$id/index'
import { Route as AuthedEventsNewIndexRouteImport } from './routes/_authed/events/new/index'
import { Route as AuthedGroupsIdIndexRouteImport } from './routes/_authed/groups/$id/index'
import { Route as AuthedGroupsIdAdminRouteImport } from './routes/_authed/groups/$id/admin'
import { Route as AuthedModerationContestIndexRouteImport } from './routes/_authed/moderation/contest/index'
import { Route as AuthedNetworksIdAdminRouteImport } from './routes/_authed/networks/$id/admin'
import { Route as AuthedSettingsAccountIndexRouteImport } from './routes/_authed/settings/account/index'
import { Route as AuthedSettingsConnectedIndexRouteImport } from './routes/_authed/settings/connected/index'
import { Route as AuthedSettingsDsrIndexRouteImport } from './routes/_authed/settings/dsr/index'
import { Route as AuthedSettingsEmailIndexRouteImport } from './routes/_authed/settings/email/index'
import { Route as AuthedSettingsNotificationsIndexRouteImport } from './routes/_authed/settings/notifications/index'
import { Route as AuthedSettingsPrivacyIndexRouteImport } from './routes/_authed/settings/privacy/index'
import { Route as AuthedSettingsSessionsIndexRouteImport } from './routes/_authed/settings/sessions/index'
import { Route as PublicCirclesIdIndexRouteImport } from './routes/_public/circles/$id/index'
import { Route as PublicNetworksIdIndexRouteImport } from './routes/_public/networks/$id/index'
import { Route as PublicResourcesIdIndexRouteImport } from './routes/_public/resources/$id/index'
import { Route as AuthedAdminBroadcastsIdIndexRouteImport } from './routes/_authed/admin/broadcasts/$id/index'
import { Route as AuthedAdminBroadcastsIdEditRouteImport } from './routes/_authed/admin/broadcasts/$id/edit'
import { Route as AuthedAdminBroadcastsNewIndexRouteImport } from './routes/_authed/admin/broadcasts/new/index'
import { Route as AuthedAdminInvitationsBulkIndexRouteImport } from './routes/_authed/admin/invitations/bulk/index'
import { Route as AuthedAdminInvitationsNewIndexRouteImport } from './routes/_authed/admin/invitations/new/index'
import { Route as AuthedAdminResourcesIdIndexRouteImport } from './routes/_authed/admin/resources/$id/index'
import { Route as AuthedAdminResourcesNewIndexRouteImport } from './routes/_authed/admin/resources/new/index'
import { Route as AuthedCirclesIdAdminIndexRouteImport } from './routes/_authed/circles/$id/admin/index'
import { Route as AuthedEventsIdEditIndexRouteImport } from './routes/_authed/events/$id/edit/index'
import { Route as AuthedGroupsIdAdminIndexRouteImport } from './routes/_authed/groups/$id/admin/index'
import { Route as AuthedModerationAutoHideNoticeHoldIdIndexRouteImport } from './routes/_authed/moderation/auto-hide-notice/$holdId/index'
import { Route as AuthedModerationContestContestationIdIndexRouteImport } from './routes/_authed/moderation/contest/$contestationId/index'
import { Route as AuthedNetworksIdAdminIndexRouteImport } from './routes/_authed/networks/$id/admin/index'
import { Route as AuthedSettingsPrivacyBlockedIndexRouteImport } from './routes/_authed/settings/privacy/blocked/index'
import { Route as PublicResourcesLearningTracksTrackIdIndexRouteImport } from './routes/_public/resources/learning-tracks/$trackId/index'
import { Route as AuthedAdminResourcesIdEditIndexRouteImport } from './routes/_authed/admin/resources/$id/edit/index'
import { Route as AuthedAdminResourcesLearningTracksTrackIdIndexRouteImport } from './routes/_authed/admin/resources/learning-tracks/$trackId/index'
import { Route as AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRouteImport } from './routes/_authed/circles/$id/admin/broadcasts/$broadcastId/index'
import { Route as AuthedCirclesIdAdminBroadcastsBroadcastIdEditRouteImport } from './routes/_authed/circles/$id/admin/broadcasts/$broadcastId/edit'
import { Route as AuthedCirclesIdAdminBroadcastsNewIndexRouteImport } from './routes/_authed/circles/$id/admin/broadcasts/new/index'
import { Route as AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRouteImport } from './routes/_authed/groups/$id/admin/broadcasts/$broadcastId/index'
import { Route as AuthedGroupsIdAdminBroadcastsBroadcastIdEditRouteImport } from './routes/_authed/groups/$id/admin/broadcasts/$broadcastId/edit'
import { Route as AuthedGroupsIdAdminBroadcastsNewIndexRouteImport } from './routes/_authed/groups/$id/admin/broadcasts/new/index'
import { Route as AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRouteImport } from './routes/_authed/networks/$id/admin/broadcasts/$broadcastId/index'
import { Route as AuthedNetworksIdAdminBroadcastsBroadcastIdEditRouteImport } from './routes/_authed/networks/$id/admin/broadcasts/$broadcastId/edit'
import { Route as AuthedNetworksIdAdminBroadcastsNewIndexRouteImport } from './routes/_authed/networks/$id/admin/broadcasts/new/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityGuidelinesRoute = CommunityGuidelinesRouteImport.update({
  id: '/community-guidelines',
  path: '/community-guidelines',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicLandingRoute = PublicLandingRouteImport.update({
  id: '/_landing',
  getParentRoute: () => PublicRoute,
} as any)
const PublicJoinACircleRoute = PublicJoinACircleRouteImport.update({
  id: '/join-a-circle',
  path: '/join-a-circle',
  getParentRoute: () => PublicRoute,
} as any)
const PublicStartACircleRoute = PublicStartACircleRouteImport.update({
  id: '/start-a-circle',
  path: '/start-a-circle',
  getParentRoute: () => PublicRoute,
} as any)
const AuthFinishingRoute = AuthFinishingRouteImport.update({
  id: '/finishing',
  path: '/finishing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthRoute,
} as any)
const InvitesTokenRoute = InvitesTokenRouteImport.update({
  id: '/invites/$token',
  path: '/invites/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingBuildSkillsRoute = OnboardingBuildSkillsRouteImport.update({
  id: '/build-skills',
  path: '/build-skills',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCirclesRoute = OnboardingCirclesRouteImport.update({
  id: '/circles',
  path: '/circles',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCompleteRoute = OnboardingCompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingGetInvolvedRoute = OnboardingGetInvolvedRouteImport.update({
  id: '/get-involved',
  path: '/get-involved',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingProfileRoute = OnboardingProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedCirclesNewRoute = AuthedCirclesNewRouteImport.update({
  id: '/circles/new',
  path: '/circles/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCoachIndexRoute = AuthedCoachIndexRouteImport.update({
  id: '/coach/',
  path: '/coach/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDirectoryIndexRoute = AuthedDirectoryIndexRouteImport.update({
  id: '/directory/',
  path: '/directory/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEventsIndexRoute = AuthedEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFeedIndexRoute = AuthedFeedIndexRouteImport.update({
  id: '/feed/',
  path: '/feed/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupsIndexRoute = AuthedGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupsNewRoute = AuthedGroupsNewRouteImport.update({
  id: '/groups/new',
  path: '/groups/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInvitationsIndexRoute = AuthedInvitationsIndexRouteImport.update({
  id: '/invitations/',
  path: '/invitations/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMembersIdRoute = AuthedMembersIdRouteImport.update({
  id: '/members/$id',
  path: '/members/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMessagesIndexRoute = AuthedMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNetworksCreateRoute = AuthedNetworksCreateRouteImport.update({
  id: '/networks/create',
  path: '/networks/create',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNetworksNewRoute = AuthedNetworksNewRouteImport.update({
  id: '/networks/new',
  path: '/networks/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNotificationsIndexRoute =
  AuthedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedPeopleIndexRoute = AuthedPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPostsIdRoute = AuthedPostsIdRouteImport.update({
  id: '/posts/$id',
  path: '/posts/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileIndexRoute = AuthedProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileMeRoute = AuthedProfileMeRouteImport.update({
  id: '/profile/me',
  path: '/profile/me',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRoadmapIndexRoute = AuthedRoadmapIndexRouteImport.update({
  id: '/roadmap/',
  path: '/roadmap/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSearchIndexRoute = AuthedSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicLandingGetStartedRoute = PublicLandingGetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => PublicLandingRoute,
} as any)
const PublicLandingJoinUsRoute = PublicLandingJoinUsRouteImport.update({
  id: '/join-us',
  path: '/join-us',
  getParentRoute: () => PublicLandingRoute,
} as any)
const PublicLandingSignInRoute = PublicLandingSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicLandingRoute,
} as any)
const PublicCirclesIndexRoute = PublicCirclesIndexRouteImport.update({
  id: '/circles/',
  path: '/circles/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicJoinANetworkIndexRoute = PublicJoinANetworkIndexRouteImport.update({
  id: '/join-a-network/',
  path: '/join-a-network/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicJoinANetworkSlugRoute = PublicJoinANetworkSlugRouteImport.update({
  id: '/join-a-network/$slug',
  path: '/join-a-network/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicJoinIndexRoute = PublicJoinIndexRouteImport.update({
  id: '/join/',
  path: '/join/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicJoinSlugRoute = PublicJoinSlugRouteImport.update({
  id: '/join/$slug',
  path: '/join/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicNetworksIndexRoute = PublicNetworksIndexRouteImport.update({
  id: '/networks/',
  path: '/networks/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResourcesIndexRoute = PublicResourcesIndexRouteImport.update({
  id: '/resources/',
  path: '/resources/',
  getParentRoute: () => PublicRoute,
} as any)
const OnboardingClCompleteRoute = OnboardingClCompleteRouteImport.update({
  id: '/cl/complete',
  path: '/cl/complete',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingClCreateCircleRoute =
  OnboardingClCreateCircleRouteImport.update({
    id: '/cl/create-circle',
    path: '/cl/create-circle',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingClWelcomeRoute = OnboardingClWelcomeRouteImport.update({
  id: '/cl/welcome',
  path: '/cl/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCmBuildSkillsRoute = OnboardingCmBuildSkillsRouteImport.update({
  id: '/cm/build-skills',
  path: '/cm/build-skills',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCmCompleteRoute = OnboardingCmCompleteRouteImport.update({
  id: '/cm/complete',
  path: '/cm/complete',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCmConnectRoute = OnboardingCmConnectRouteImport.update({
  id: '/cm/connect',
  path: '/cm/connect',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCmFindCircleRoute = OnboardingCmFindCircleRouteImport.update({
  id: '/cm/find-circle',
  path: '/cm/find-circle',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCmWelcomeRoute = OnboardingCmWelcomeRouteImport.update({
  id: '/cm/welcome',
  path: '/cm/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingJAboutRoute = OnboardingJAboutRouteImport.update({
  id: '/j/about',
  path: '/j/about',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingJCircleRoute = OnboardingJCircleRouteImport.update({
  id: '/j/circle',
  path: '/j/circle',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingJYoureInRoute = OnboardingJYoureInRouteImport.update({
  id: '/j/youre-in',
  path: '/j/youre-in',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingNlAccessNetworkRoute =
  OnboardingNlAccessNetworkRouteImport.update({
    id: '/nl/access-network',
    path: '/nl/access-network',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingNlCompleteRoute = OnboardingNlCompleteRouteImport.update({
  id: '/nl/complete',
  path: '/nl/complete',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingNlHubRoute = OnboardingNlHubRouteImport.update({
  id: '/nl/hub',
  path: '/nl/hub',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingNlManageNetworkRoute =
  OnboardingNlManageNetworkRouteImport.update({
    id: '/nl/manage-network',
    path: '/nl/manage-network',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingNlNetworkPageRoute = OnboardingNlNetworkPageRouteImport.update({
  id: '/nl/network-page',
  path: '/nl/network-page',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingNlWelcomeRoute = OnboardingNlWelcomeRouteImport.update({
  id: '/nl/welcome',
  path: '/nl/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const AuthedAdminBroadcastsIndexRoute =
  AuthedAdminBroadcastsIndexRouteImport.update({
    id: '/broadcasts/',
    path: '/broadcasts/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminCoachIndexRoute = AuthedAdminCoachIndexRouteImport.update({
  id: '/coach/',
  path: '/coach/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminDsrIndexRoute = AuthedAdminDsrIndexRouteImport.update({
  id: '/dsr/',
  path: '/dsr/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminFeatureFlagsIndexRoute =
  AuthedAdminFeatureFlagsIndexRouteImport.update({
    id: '/feature-flags/',
    path: '/feature-flags/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminInvitationsIndexRoute =
  AuthedAdminInvitationsIndexRouteImport.update({
    id: '/invitations/',
    path: '/invitations/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminMembersIndexRoute = AuthedAdminMembersIndexRouteImport.update({
  id: '/members/',
  path: '/members/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminMembersUserIdRoute =
  AuthedAdminMembersUserIdRouteImport.update({
    id: '/members/$userId',
    path: '/members/$userId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminModerationIndexRoute =
  AuthedAdminModerationIndexRouteImport.update({
    id: '/moderation/',
    path: '/moderation/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminModerationReportIdRoute =
  AuthedAdminModerationReportIdRouteImport.update({
    id: '/moderation/$reportId',
    path: '/moderation/$reportId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminResourcesIndexRoute =
  AuthedAdminResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminRoadmapIndexRoute = AuthedAdminRoadmapIndexRouteImport.update({
  id: '/roadmap/',
  path: '/roadmap/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminRoadmapItemIdRoute =
  AuthedAdminRoadmapItemIdRouteImport.update({
    id: '/roadmap/$itemId',
    path: '/roadmap/$itemId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminTopicsIndexRoute = AuthedAdminTopicsIndexRouteImport.update({
  id: '/topics/',
  path: '/topics/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminTopicsTopicIdRoute =
  AuthedAdminTopicsTopicIdRouteImport.update({
    id: '/topics/$topicId',
    path: '/topics/$topicId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminUserResearchIndexRoute =
  AuthedAdminUserResearchIndexRouteImport.update({
    id: '/user-research/',
    path: '/user-research/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedCirclesIdAdminRoute = AuthedCirclesIdAdminRouteImport.update({
  id: '/circles/$id/admin',
  path: '/circles/$id/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCirclesIdEditRoute = AuthedCirclesIdEditRouteImport.update({
  id: '/circles/$id/edit',
  path: '/circles/$id/edit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEventsIdIndexRoute = AuthedEventsIdIndexRouteImport.update({
  id: '/events/$id/',
  path: '/events/$id/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEventsNewIndexRoute = AuthedEventsNewIndexRouteImport.update({
  id: '/events/new/',
  path: '/events/new/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupsIdIndexRoute = AuthedGroupsIdIndexRouteImport.update({
  id: '/groups/$id/',
  path: '/groups/$id/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupsIdAdminRoute = AuthedGroupsIdAdminRouteImport.update({
  id: '/groups/$id/admin',
  path: '/groups/$id/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedModerationContestIndexRoute =
  AuthedModerationContestIndexRouteImport.update({
    id: '/moderation/contest/',
    path: '/moderation/contest/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedNetworksIdAdminRoute = AuthedNetworksIdAdminRouteImport.update({
  id: '/networks/$id/admin',
  path: '/networks/$id/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsAccountIndexRoute =
  AuthedSettingsAccountIndexRouteImport.update({
    id: '/settings/account/',
    path: '/settings/account/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsConnectedIndexRoute =
  AuthedSettingsConnectedIndexRouteImport.update({
    id: '/settings/connected/',
    path: '/settings/connected/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsDsrIndexRoute = AuthedSettingsDsrIndexRouteImport.update({
  id: '/settings/dsr/',
  path: '/settings/dsr/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsEmailIndexRoute =
  AuthedSettingsEmailIndexRouteImport.update({
    id: '/settings/email/',
    path: '/settings/email/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsNotificationsIndexRoute =
  AuthedSettingsNotificationsIndexRouteImport.update({
    id: '/settings/notifications/',
    path: '/settings/notifications/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsPrivacyIndexRoute =
  AuthedSettingsPrivacyIndexRouteImport.update({
    id: '/settings/privacy/',
    path: '/settings/privacy/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsSessionsIndexRoute =
  AuthedSettingsSessionsIndexRouteImport.update({
    id: '/settings/sessions/',
    path: '/settings/sessions/',
    getParentRoute: () => AuthedRoute,
  } as any)
const PublicCirclesIdIndexRoute = PublicCirclesIdIndexRouteImport.update({
  id: '/circles/$id/',
  path: '/circles/$id/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicNetworksIdIndexRoute = PublicNetworksIdIndexRouteImport.update({
  id: '/networks/$id/',
  path: '/networks/$id/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResourcesIdIndexRoute = PublicResourcesIdIndexRouteImport.update({
  id: '/resources/$id/',
  path: '/resources/$id/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedAdminBroadcastsIdIndexRoute =
  AuthedAdminBroadcastsIdIndexRouteImport.update({
    id: '/broadcasts/$id/',
    path: '/broadcasts/$id/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminBroadcastsIdEditRoute =
  AuthedAdminBroadcastsIdEditRouteImport.update({
    id: '/broadcasts/$id/edit',
    path: '/broadcasts/$id/edit',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminBroadcastsNewIndexRoute =
  AuthedAdminBroadcastsNewIndexRouteImport.update({
    id: '/broadcasts/new/',
    path: '/broadcasts/new/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminInvitationsBulkIndexRoute =
  AuthedAdminInvitationsBulkIndexRouteImport.update({
    id: '/invitations/bulk/',
    path: '/invitations/bulk/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminInvitationsNewIndexRoute =
  AuthedAdminInvitationsNewIndexRouteImport.update({
    id: '/invitations/new/',
    path: '/invitations/new/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminResourcesIdIndexRoute =
  AuthedAdminResourcesIdIndexRouteImport.update({
    id: '/resources/$id/',
    path: '/resources/$id/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminResourcesNewIndexRoute =
  AuthedAdminResourcesNewIndexRouteImport.update({
    id: '/resources/new/',
    path: '/resources/new/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedCirclesIdAdminIndexRoute =
  AuthedCirclesIdAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedCirclesIdAdminRoute,
  } as any)
const AuthedEventsIdEditIndexRoute = AuthedEventsIdEditIndexRouteImport.update({
  id: '/events/$id/edit/',
  path: '/events/$id/edit/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupsIdAdminIndexRoute =
  AuthedGroupsIdAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedGroupsIdAdminRoute,
  } as any)
const AuthedModerationAutoHideNoticeHoldIdIndexRoute =
  AuthedModerationAutoHideNoticeHoldIdIndexRouteImport.update({
    id: '/moderation/auto-hide-notice/$holdId/',
    path: '/moderation/auto-hide-notice/$holdId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedModerationContestContestationIdIndexRoute =
  AuthedModerationContestContestationIdIndexRouteImport.update({
    id: '/moderation/contest/$contestationId/',
    path: '/moderation/contest/$contestationId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedNetworksIdAdminIndexRoute =
  AuthedNetworksIdAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedNetworksIdAdminRoute,
  } as any)
const AuthedSettingsPrivacyBlockedIndexRoute =
  AuthedSettingsPrivacyBlockedIndexRouteImport.update({
    id: '/settings/privacy/blocked/',
    path: '/settings/privacy/blocked/',
    getParentRoute: () => AuthedRoute,
  } as any)
const PublicResourcesLearningTracksTrackIdIndexRoute =
  PublicResourcesLearningTracksTrackIdIndexRouteImport.update({
    id: '/resources/learning-tracks/$trackId/',
    path: '/resources/learning-tracks/$trackId/',
    getParentRoute: () => PublicRoute,
  } as any)
const AuthedAdminResourcesIdEditIndexRoute =
  AuthedAdminResourcesIdEditIndexRouteImport.update({
    id: '/resources/$id/edit/',
    path: '/resources/$id/edit/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminResourcesLearningTracksTrackIdIndexRoute =
  AuthedAdminResourcesLearningTracksTrackIdIndexRouteImport.update({
    id: '/resources/learning-tracks/$trackId/',
    path: '/resources/learning-tracks/$trackId/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute =
  AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRouteImport.update({
    id: '/broadcasts/$broadcastId/',
    path: '/broadcasts/$broadcastId/',
    getParentRoute: () => AuthedCirclesIdAdminRoute,
  } as any)
const AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute =
  AuthedCirclesIdAdminBroadcastsBroadcastIdEditRouteImport.update({
    id: '/broadcasts/$broadcastId/edit',
    path: '/broadcasts/$broadcastId/edit',
    getParentRoute: () => AuthedCirclesIdAdminRoute,
  } as any)
const AuthedCirclesIdAdminBroadcastsNewIndexRoute =
  AuthedCirclesIdAdminBroadcastsNewIndexRouteImport.update({
    id: '/broadcasts/new/',
    path: '/broadcasts/new/',
    getParentRoute: () => AuthedCirclesIdAdminRoute,
  } as any)
const AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute =
  AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRouteImport.update({
    id: '/broadcasts/$broadcastId/',
    path: '/broadcasts/$broadcastId/',
    getParentRoute: () => AuthedGroupsIdAdminRoute,
  } as any)
const AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute =
  AuthedGroupsIdAdminBroadcastsBroadcastIdEditRouteImport.update({
    id: '/broadcasts/$broadcastId/edit',
    path: '/broadcasts/$broadcastId/edit',
    getParentRoute: () => AuthedGroupsIdAdminRoute,
  } as any)
const AuthedGroupsIdAdminBroadcastsNewIndexRoute =
  AuthedGroupsIdAdminBroadcastsNewIndexRouteImport.update({
    id: '/broadcasts/new/',
    path: '/broadcasts/new/',
    getParentRoute: () => AuthedGroupsIdAdminRoute,
  } as any)
const AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute =
  AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRouteImport.update({
    id: '/broadcasts/$broadcastId/',
    path: '/broadcasts/$broadcastId/',
    getParentRoute: () => AuthedNetworksIdAdminRoute,
  } as any)
const AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute =
  AuthedNetworksIdAdminBroadcastsBroadcastIdEditRouteImport.update({
    id: '/broadcasts/$broadcastId/edit',
    path: '/broadcasts/$broadcastId/edit',
    getParentRoute: () => AuthedNetworksIdAdminRoute,
  } as any)
const AuthedNetworksIdAdminBroadcastsNewIndexRoute =
  AuthedNetworksIdAdminBroadcastsNewIndexRouteImport.update({
    id: '/broadcasts/new/',
    path: '/broadcasts/new/',
    getParentRoute: () => AuthedNetworksIdAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/help': typeof HelpRoute
  '/not-found': typeof NotFoundRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/join-a-circle': typeof PublicJoinACircleRoute
  '/start-a-circle': typeof PublicStartACircleRoute
  '/auth/finishing': typeof AuthFinishingRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/onboarding/build-skills': typeof OnboardingBuildSkillsRoute
  '/onboarding/circles': typeof OnboardingCirclesRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/get-involved': typeof OnboardingGetInvolvedRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/circles/new': typeof AuthedCirclesNewRoute
  '/groups/new': typeof AuthedGroupsNewRoute
  '/members/$id': typeof AuthedMembersIdRoute
  '/networks/create': typeof AuthedNetworksCreateRoute
  '/networks/new': typeof AuthedNetworksNewRoute
  '/posts/$id': typeof AuthedPostsIdRoute
  '/profile/me': typeof AuthedProfileMeRoute
  '/get-started': typeof PublicLandingGetStartedRoute
  '/join-us': typeof PublicLandingJoinUsRoute
  '/sign-in': typeof PublicLandingSignInRoute
  '/join-a-network/$slug': typeof PublicJoinANetworkSlugRoute
  '/join/$slug': typeof PublicJoinSlugRoute
  '/onboarding/cl/complete': typeof OnboardingClCompleteRoute
  '/onboarding/cl/create-circle': typeof OnboardingClCreateCircleRoute
  '/onboarding/cl/welcome': typeof OnboardingClWelcomeRoute
  '/onboarding/cm/build-skills': typeof OnboardingCmBuildSkillsRoute
  '/onboarding/cm/complete': typeof OnboardingCmCompleteRoute
  '/onboarding/cm/connect': typeof OnboardingCmConnectRoute
  '/onboarding/cm/find-circle': typeof OnboardingCmFindCircleRoute
  '/onboarding/cm/welcome': typeof OnboardingCmWelcomeRoute
  '/onboarding/j/about': typeof OnboardingJAboutRoute
  '/onboarding/j/circle': typeof OnboardingJCircleRoute
  '/onboarding/j/youre-in': typeof OnboardingJYoureInRoute
  '/onboarding/nl/access-network': typeof OnboardingNlAccessNetworkRoute
  '/onboarding/nl/complete': typeof OnboardingNlCompleteRoute
  '/onboarding/nl/hub': typeof OnboardingNlHubRoute
  '/onboarding/nl/manage-network': typeof OnboardingNlManageNetworkRoute
  '/onboarding/nl/network-page': typeof OnboardingNlNetworkPageRoute
  '/onboarding/nl/welcome': typeof OnboardingNlWelcomeRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/coach/': typeof AuthedCoachIndexRoute
  '/directory/': typeof AuthedDirectoryIndexRoute
  '/events/': typeof AuthedEventsIndexRoute
  '/feed/': typeof AuthedFeedIndexRoute
  '/groups/': typeof AuthedGroupsIndexRoute
  '/invitations/': typeof AuthedInvitationsIndexRoute
  '/messages/': typeof AuthedMessagesIndexRoute
  '/notifications/': typeof AuthedNotificationsIndexRoute
  '/people/': typeof AuthedPeopleIndexRoute
  '/profile/': typeof AuthedProfileIndexRoute
  '/roadmap/': typeof AuthedRoadmapIndexRoute
  '/search/': typeof AuthedSearchIndexRoute
  '/settings/': typeof AuthedSettingsIndexRoute
  '/circles/': typeof PublicCirclesIndexRoute
  '/join-a-network/': typeof PublicJoinANetworkIndexRoute
  '/join/': typeof PublicJoinIndexRoute
  '/networks/': typeof PublicNetworksIndexRoute
  '/resources/': typeof PublicResourcesIndexRoute
  '/admin/members/$userId': typeof AuthedAdminMembersUserIdRoute
  '/admin/moderation/$reportId': typeof AuthedAdminModerationReportIdRoute
  '/admin/roadmap/$itemId': typeof AuthedAdminRoadmapItemIdRoute
  '/admin/topics/$topicId': typeof AuthedAdminTopicsTopicIdRoute
  '/circles/$id/admin': typeof AuthedCirclesIdAdminRouteWithChildren
  '/circles/$id/edit': typeof AuthedCirclesIdEditRoute
  '/groups/$id/admin': typeof AuthedGroupsIdAdminRouteWithChildren
  '/networks/$id/admin': typeof AuthedNetworksIdAdminRouteWithChildren
  '/admin/broadcasts/': typeof AuthedAdminBroadcastsIndexRoute
  '/admin/coach/': typeof AuthedAdminCoachIndexRoute
  '/admin/dsr/': typeof AuthedAdminDsrIndexRoute
  '/admin/feature-flags/': typeof AuthedAdminFeatureFlagsIndexRoute
  '/admin/invitations/': typeof AuthedAdminInvitationsIndexRoute
  '/admin/members/': typeof AuthedAdminMembersIndexRoute
  '/admin/moderation/': typeof AuthedAdminModerationIndexRoute
  '/admin/resources/': typeof AuthedAdminResourcesIndexRoute
  '/admin/roadmap/': typeof AuthedAdminRoadmapIndexRoute
  '/admin/topics/': typeof AuthedAdminTopicsIndexRoute
  '/admin/user-research/': typeof AuthedAdminUserResearchIndexRoute
  '/events/$id/': typeof AuthedEventsIdIndexRoute
  '/events/new/': typeof AuthedEventsNewIndexRoute
  '/groups/$id/': typeof AuthedGroupsIdIndexRoute
  '/moderation/contest/': typeof AuthedModerationContestIndexRoute
  '/settings/account/': typeof AuthedSettingsAccountIndexRoute
  '/settings/connected/': typeof AuthedSettingsConnectedIndexRoute
  '/settings/dsr/': typeof AuthedSettingsDsrIndexRoute
  '/settings/email/': typeof AuthedSettingsEmailIndexRoute
  '/settings/notifications/': typeof AuthedSettingsNotificationsIndexRoute
  '/settings/privacy/': typeof AuthedSettingsPrivacyIndexRoute
  '/settings/sessions/': typeof AuthedSettingsSessionsIndexRoute
  '/circles/$id/': typeof PublicCirclesIdIndexRoute
  '/networks/$id/': typeof PublicNetworksIdIndexRoute
  '/resources/$id/': typeof PublicResourcesIdIndexRoute
  '/admin/broadcasts/$id/edit': typeof AuthedAdminBroadcastsIdEditRoute
  '/admin/broadcasts/$id/': typeof AuthedAdminBroadcastsIdIndexRoute
  '/admin/broadcasts/new/': typeof AuthedAdminBroadcastsNewIndexRoute
  '/admin/invitations/bulk/': typeof AuthedAdminInvitationsBulkIndexRoute
  '/admin/invitations/new/': typeof AuthedAdminInvitationsNewIndexRoute
  '/admin/resources/$id/': typeof AuthedAdminResourcesIdIndexRoute
  '/admin/resources/new/': typeof AuthedAdminResourcesNewIndexRoute
  '/circles/$id/admin/': typeof AuthedCirclesIdAdminIndexRoute
  '/events/$id/edit/': typeof AuthedEventsIdEditIndexRoute
  '/groups/$id/admin/': typeof AuthedGroupsIdAdminIndexRoute
  '/moderation/auto-hide-notice/$holdId/': typeof AuthedModerationAutoHideNoticeHoldIdIndexRoute
  '/moderation/contest/$contestationId/': typeof AuthedModerationContestContestationIdIndexRoute
  '/networks/$id/admin/': typeof AuthedNetworksIdAdminIndexRoute
  '/settings/privacy/blocked/': typeof AuthedSettingsPrivacyBlockedIndexRoute
  '/resources/learning-tracks/$trackId/': typeof PublicResourcesLearningTracksTrackIdIndexRoute
  '/admin/resources/$id/edit/': typeof AuthedAdminResourcesIdEditIndexRoute
  '/admin/resources/learning-tracks/$trackId/': typeof AuthedAdminResourcesLearningTracksTrackIdIndexRoute
  '/circles/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute
  '/groups/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute
  '/networks/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute
  '/circles/$id/admin/broadcasts/$broadcastId/': typeof AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute
  '/circles/$id/admin/broadcasts/new/': typeof AuthedCirclesIdAdminBroadcastsNewIndexRoute
  '/groups/$id/admin/broadcasts/$broadcastId/': typeof AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute
  '/groups/$id/admin/broadcasts/new/': typeof AuthedGroupsIdAdminBroadcastsNewIndexRoute
  '/networks/$id/admin/broadcasts/$broadcastId/': typeof AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute
  '/networks/$id/admin/broadcasts/new/': typeof AuthedNetworksIdAdminBroadcastsNewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/help': typeof HelpRoute
  '/not-found': typeof NotFoundRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/join-a-circle': typeof PublicJoinACircleRoute
  '/start-a-circle': typeof PublicStartACircleRoute
  '/auth/finishing': typeof AuthFinishingRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/onboarding/build-skills': typeof OnboardingBuildSkillsRoute
  '/onboarding/circles': typeof OnboardingCirclesRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/get-involved': typeof OnboardingGetInvolvedRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/circles/new': typeof AuthedCirclesNewRoute
  '/groups/new': typeof AuthedGroupsNewRoute
  '/members/$id': typeof AuthedMembersIdRoute
  '/networks/create': typeof AuthedNetworksCreateRoute
  '/networks/new': typeof AuthedNetworksNewRoute
  '/posts/$id': typeof AuthedPostsIdRoute
  '/profile/me': typeof AuthedProfileMeRoute
  '/get-started': typeof PublicLandingGetStartedRoute
  '/join-us': typeof PublicLandingJoinUsRoute
  '/sign-in': typeof PublicLandingSignInRoute
  '/join-a-network/$slug': typeof PublicJoinANetworkSlugRoute
  '/join/$slug': typeof PublicJoinSlugRoute
  '/onboarding/cl/complete': typeof OnboardingClCompleteRoute
  '/onboarding/cl/create-circle': typeof OnboardingClCreateCircleRoute
  '/onboarding/cl/welcome': typeof OnboardingClWelcomeRoute
  '/onboarding/cm/build-skills': typeof OnboardingCmBuildSkillsRoute
  '/onboarding/cm/complete': typeof OnboardingCmCompleteRoute
  '/onboarding/cm/connect': typeof OnboardingCmConnectRoute
  '/onboarding/cm/find-circle': typeof OnboardingCmFindCircleRoute
  '/onboarding/cm/welcome': typeof OnboardingCmWelcomeRoute
  '/onboarding/j/about': typeof OnboardingJAboutRoute
  '/onboarding/j/circle': typeof OnboardingJCircleRoute
  '/onboarding/j/youre-in': typeof OnboardingJYoureInRoute
  '/onboarding/nl/access-network': typeof OnboardingNlAccessNetworkRoute
  '/onboarding/nl/complete': typeof OnboardingNlCompleteRoute
  '/onboarding/nl/hub': typeof OnboardingNlHubRoute
  '/onboarding/nl/manage-network': typeof OnboardingNlManageNetworkRoute
  '/onboarding/nl/network-page': typeof OnboardingNlNetworkPageRoute
  '/onboarding/nl/welcome': typeof OnboardingNlWelcomeRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/coach': typeof AuthedCoachIndexRoute
  '/directory': typeof AuthedDirectoryIndexRoute
  '/events': typeof AuthedEventsIndexRoute
  '/feed': typeof AuthedFeedIndexRoute
  '/groups': typeof AuthedGroupsIndexRoute
  '/invitations': typeof AuthedInvitationsIndexRoute
  '/messages': typeof AuthedMessagesIndexRoute
  '/notifications': typeof AuthedNotificationsIndexRoute
  '/people': typeof AuthedPeopleIndexRoute
  '/profile': typeof AuthedProfileIndexRoute
  '/roadmap': typeof AuthedRoadmapIndexRoute
  '/search': typeof AuthedSearchIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
  '/circles': typeof PublicCirclesIndexRoute
  '/join-a-network': typeof PublicJoinANetworkIndexRoute
  '/join': typeof PublicJoinIndexRoute
  '/networks': typeof PublicNetworksIndexRoute
  '/resources': typeof PublicResourcesIndexRoute
  '/admin/members/$userId': typeof AuthedAdminMembersUserIdRoute
  '/admin/moderation/$reportId': typeof AuthedAdminModerationReportIdRoute
  '/admin/roadmap/$itemId': typeof AuthedAdminRoadmapItemIdRoute
  '/admin/topics/$topicId': typeof AuthedAdminTopicsTopicIdRoute
  '/circles/$id/edit': typeof AuthedCirclesIdEditRoute
  '/admin/broadcasts': typeof AuthedAdminBroadcastsIndexRoute
  '/admin/coach': typeof AuthedAdminCoachIndexRoute
  '/admin/dsr': typeof AuthedAdminDsrIndexRoute
  '/admin/feature-flags': typeof AuthedAdminFeatureFlagsIndexRoute
  '/admin/invitations': typeof AuthedAdminInvitationsIndexRoute
  '/admin/members': typeof AuthedAdminMembersIndexRoute
  '/admin/moderation': typeof AuthedAdminModerationIndexRoute
  '/admin/resources': typeof AuthedAdminResourcesIndexRoute
  '/admin/roadmap': typeof AuthedAdminRoadmapIndexRoute
  '/admin/topics': typeof AuthedAdminTopicsIndexRoute
  '/admin/user-research': typeof AuthedAdminUserResearchIndexRoute
  '/events/$id': typeof AuthedEventsIdIndexRoute
  '/events/new': typeof AuthedEventsNewIndexRoute
  '/groups/$id': typeof AuthedGroupsIdIndexRoute
  '/moderation/contest': typeof AuthedModerationContestIndexRoute
  '/settings/account': typeof AuthedSettingsAccountIndexRoute
  '/settings/connected': typeof AuthedSettingsConnectedIndexRoute
  '/settings/dsr': typeof AuthedSettingsDsrIndexRoute
  '/settings/email': typeof AuthedSettingsEmailIndexRoute
  '/settings/notifications': typeof AuthedSettingsNotificationsIndexRoute
  '/settings/privacy': typeof AuthedSettingsPrivacyIndexRoute
  '/settings/sessions': typeof AuthedSettingsSessionsIndexRoute
  '/circles/$id': typeof PublicCirclesIdIndexRoute
  '/networks/$id': typeof PublicNetworksIdIndexRoute
  '/resources/$id': typeof PublicResourcesIdIndexRoute
  '/admin/broadcasts/$id/edit': typeof AuthedAdminBroadcastsIdEditRoute
  '/admin/broadcasts/$id': typeof AuthedAdminBroadcastsIdIndexRoute
  '/admin/broadcasts/new': typeof AuthedAdminBroadcastsNewIndexRoute
  '/admin/invitations/bulk': typeof AuthedAdminInvitationsBulkIndexRoute
  '/admin/invitations/new': typeof AuthedAdminInvitationsNewIndexRoute
  '/admin/resources/$id': typeof AuthedAdminResourcesIdIndexRoute
  '/admin/resources/new': typeof AuthedAdminResourcesNewIndexRoute
  '/circles/$id/admin': typeof AuthedCirclesIdAdminIndexRoute
  '/events/$id/edit': typeof AuthedEventsIdEditIndexRoute
  '/groups/$id/admin': typeof AuthedGroupsIdAdminIndexRoute
  '/moderation/auto-hide-notice/$holdId': typeof AuthedModerationAutoHideNoticeHoldIdIndexRoute
  '/moderation/contest/$contestationId': typeof AuthedModerationContestContestationIdIndexRoute
  '/networks/$id/admin': typeof AuthedNetworksIdAdminIndexRoute
  '/settings/privacy/blocked': typeof AuthedSettingsPrivacyBlockedIndexRoute
  '/resources/learning-tracks/$trackId': typeof PublicResourcesLearningTracksTrackIdIndexRoute
  '/admin/resources/$id/edit': typeof AuthedAdminResourcesIdEditIndexRoute
  '/admin/resources/learning-tracks/$trackId': typeof AuthedAdminResourcesLearningTracksTrackIdIndexRoute
  '/circles/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute
  '/groups/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute
  '/networks/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute
  '/circles/$id/admin/broadcasts/$broadcastId': typeof AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute
  '/circles/$id/admin/broadcasts/new': typeof AuthedCirclesIdAdminBroadcastsNewIndexRoute
  '/groups/$id/admin/broadcasts/$broadcastId': typeof AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute
  '/groups/$id/admin/broadcasts/new': typeof AuthedGroupsIdAdminBroadcastsNewIndexRoute
  '/networks/$id/admin/broadcasts/$broadcastId': typeof AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute
  '/networks/$id/admin/broadcasts/new': typeof AuthedNetworksIdAdminBroadcastsNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/community-guidelines': typeof CommunityGuidelinesRoute
  '/help': typeof HelpRoute
  '/not-found': typeof NotFoundRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_public/_landing': typeof PublicLandingRouteWithChildren
  '/_public/join-a-circle': typeof PublicJoinACircleRoute
  '/_public/start-a-circle': typeof PublicStartACircleRoute
  '/auth/finishing': typeof AuthFinishingRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/onboarding/build-skills': typeof OnboardingBuildSkillsRoute
  '/onboarding/circles': typeof OnboardingCirclesRoute
  '/onboarding/complete': typeof OnboardingCompleteRoute
  '/onboarding/get-involved': typeof OnboardingGetInvolvedRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/_authed/circles/new': typeof AuthedCirclesNewRoute
  '/_authed/groups/new': typeof AuthedGroupsNewRoute
  '/_authed/members/$id': typeof AuthedMembersIdRoute
  '/_authed/networks/create': typeof AuthedNetworksCreateRoute
  '/_authed/networks/new': typeof AuthedNetworksNewRoute
  '/_authed/posts/$id': typeof AuthedPostsIdRoute
  '/_authed/profile/me': typeof AuthedProfileMeRoute
  '/_public/_landing/get-started': typeof PublicLandingGetStartedRoute
  '/_public/_landing/join-us': typeof PublicLandingJoinUsRoute
  '/_public/_landing/sign-in': typeof PublicLandingSignInRoute
  '/_public/join-a-network/$slug': typeof PublicJoinANetworkSlugRoute
  '/_public/join/$slug': typeof PublicJoinSlugRoute
  '/onboarding/cl/complete': typeof OnboardingClCompleteRoute
  '/onboarding/cl/create-circle': typeof OnboardingClCreateCircleRoute
  '/onboarding/cl/welcome': typeof OnboardingClWelcomeRoute
  '/onboarding/cm/build-skills': typeof OnboardingCmBuildSkillsRoute
  '/onboarding/cm/complete': typeof OnboardingCmCompleteRoute
  '/onboarding/cm/connect': typeof OnboardingCmConnectRoute
  '/onboarding/cm/find-circle': typeof OnboardingCmFindCircleRoute
  '/onboarding/cm/welcome': typeof OnboardingCmWelcomeRoute
  '/onboarding/j/about': typeof OnboardingJAboutRoute
  '/onboarding/j/circle': typeof OnboardingJCircleRoute
  '/onboarding/j/youre-in': typeof OnboardingJYoureInRoute
  '/onboarding/nl/access-network': typeof OnboardingNlAccessNetworkRoute
  '/onboarding/nl/complete': typeof OnboardingNlCompleteRoute
  '/onboarding/nl/hub': typeof OnboardingNlHubRoute
  '/onboarding/nl/manage-network': typeof OnboardingNlManageNetworkRoute
  '/onboarding/nl/network-page': typeof OnboardingNlNetworkPageRoute
  '/onboarding/nl/welcome': typeof OnboardingNlWelcomeRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/coach/': typeof AuthedCoachIndexRoute
  '/_authed/directory/': typeof AuthedDirectoryIndexRoute
  '/_authed/events/': typeof AuthedEventsIndexRoute
  '/_authed/feed/': typeof AuthedFeedIndexRoute
  '/_authed/groups/': typeof AuthedGroupsIndexRoute
  '/_authed/invitations/': typeof AuthedInvitationsIndexRoute
  '/_authed/messages/': typeof AuthedMessagesIndexRoute
  '/_authed/notifications/': typeof AuthedNotificationsIndexRoute
  '/_authed/people/': typeof AuthedPeopleIndexRoute
  '/_authed/profile/': typeof AuthedProfileIndexRoute
  '/_authed/roadmap/': typeof AuthedRoadmapIndexRoute
  '/_authed/search/': typeof AuthedSearchIndexRoute
  '/_authed/settings/': typeof AuthedSettingsIndexRoute
  '/_public/circles/': typeof PublicCirclesIndexRoute
  '/_public/join-a-network/': typeof PublicJoinANetworkIndexRoute
  '/_public/join/': typeof PublicJoinIndexRoute
  '/_public/networks/': typeof PublicNetworksIndexRoute
  '/_public/resources/': typeof PublicResourcesIndexRoute
  '/_authed/admin/members/$userId': typeof AuthedAdminMembersUserIdRoute
  '/_authed/admin/moderation/$reportId': typeof AuthedAdminModerationReportIdRoute
  '/_authed/admin/roadmap/$itemId': typeof AuthedAdminRoadmapItemIdRoute
  '/_authed/admin/topics/$topicId': typeof AuthedAdminTopicsTopicIdRoute
  '/_authed/circles/$id/admin': typeof AuthedCirclesIdAdminRouteWithChildren
  '/_authed/circles/$id/edit': typeof AuthedCirclesIdEditRoute
  '/_authed/groups/$id/admin': typeof AuthedGroupsIdAdminRouteWithChildren
  '/_authed/networks/$id/admin': typeof AuthedNetworksIdAdminRouteWithChildren
  '/_authed/admin/broadcasts/': typeof AuthedAdminBroadcastsIndexRoute
  '/_authed/admin/coach/': typeof AuthedAdminCoachIndexRoute
  '/_authed/admin/dsr/': typeof AuthedAdminDsrIndexRoute
  '/_authed/admin/feature-flags/': typeof AuthedAdminFeatureFlagsIndexRoute
  '/_authed/admin/invitations/': typeof AuthedAdminInvitationsIndexRoute
  '/_authed/admin/members/': typeof AuthedAdminMembersIndexRoute
  '/_authed/admin/moderation/': typeof AuthedAdminModerationIndexRoute
  '/_authed/admin/resources/': typeof AuthedAdminResourcesIndexRoute
  '/_authed/admin/roadmap/': typeof AuthedAdminRoadmapIndexRoute
  '/_authed/admin/topics/': typeof AuthedAdminTopicsIndexRoute
  '/_authed/admin/user-research/': typeof AuthedAdminUserResearchIndexRoute
  '/_authed/events/$id/': typeof AuthedEventsIdIndexRoute
  '/_authed/events/new/': typeof AuthedEventsNewIndexRoute
  '/_authed/groups/$id/': typeof AuthedGroupsIdIndexRoute
  '/_authed/moderation/contest/': typeof AuthedModerationContestIndexRoute
  '/_authed/settings/account/': typeof AuthedSettingsAccountIndexRoute
  '/_authed/settings/connected/': typeof AuthedSettingsConnectedIndexRoute
  '/_authed/settings/dsr/': typeof AuthedSettingsDsrIndexRoute
  '/_authed/settings/email/': typeof AuthedSettingsEmailIndexRoute
  '/_authed/settings/notifications/': typeof AuthedSettingsNotificationsIndexRoute
  '/_authed/settings/privacy/': typeof AuthedSettingsPrivacyIndexRoute
  '/_authed/settings/sessions/': typeof AuthedSettingsSessionsIndexRoute
  '/_public/circles/$id/': typeof PublicCirclesIdIndexRoute
  '/_public/networks/$id/': typeof PublicNetworksIdIndexRoute
  '/_public/resources/$id/': typeof PublicResourcesIdIndexRoute
  '/_authed/admin/broadcasts/$id/edit': typeof AuthedAdminBroadcastsIdEditRoute
  '/_authed/admin/broadcasts/$id/': typeof AuthedAdminBroadcastsIdIndexRoute
  '/_authed/admin/broadcasts/new/': typeof AuthedAdminBroadcastsNewIndexRoute
  '/_authed/admin/invitations/bulk/': typeof AuthedAdminInvitationsBulkIndexRoute
  '/_authed/admin/invitations/new/': typeof AuthedAdminInvitationsNewIndexRoute
  '/_authed/admin/resources/$id/': typeof AuthedAdminResourcesIdIndexRoute
  '/_authed/admin/resources/new/': typeof AuthedAdminResourcesNewIndexRoute
  '/_authed/circles/$id/admin/': typeof AuthedCirclesIdAdminIndexRoute
  '/_authed/events/$id/edit/': typeof AuthedEventsIdEditIndexRoute
  '/_authed/groups/$id/admin/': typeof AuthedGroupsIdAdminIndexRoute
  '/_authed/moderation/auto-hide-notice/$holdId/': typeof AuthedModerationAutoHideNoticeHoldIdIndexRoute
  '/_authed/moderation/contest/$contestationId/': typeof AuthedModerationContestContestationIdIndexRoute
  '/_authed/networks/$id/admin/': typeof AuthedNetworksIdAdminIndexRoute
  '/_authed/settings/privacy/blocked/': typeof AuthedSettingsPrivacyBlockedIndexRoute
  '/_public/resources/learning-tracks/$trackId/': typeof PublicResourcesLearningTracksTrackIdIndexRoute
  '/_authed/admin/resources/$id/edit/': typeof AuthedAdminResourcesIdEditIndexRoute
  '/_authed/admin/resources/learning-tracks/$trackId/': typeof AuthedAdminResourcesLearningTracksTrackIdIndexRoute
  '/_authed/circles/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute
  '/_authed/groups/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute
  '/_authed/networks/$id/admin/broadcasts/$broadcastId/edit': typeof AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute
  '/_authed/circles/$id/admin/broadcasts/$broadcastId/': typeof AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute
  '/_authed/circles/$id/admin/broadcasts/new/': typeof AuthedCirclesIdAdminBroadcastsNewIndexRoute
  '/_authed/groups/$id/admin/broadcasts/$broadcastId/': typeof AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute
  '/_authed/groups/$id/admin/broadcasts/new/': typeof AuthedGroupsIdAdminBroadcastsNewIndexRoute
  '/_authed/networks/$id/admin/broadcasts/$broadcastId/': typeof AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute
  '/_authed/networks/$id/admin/broadcasts/new/': typeof AuthedNetworksIdAdminBroadcastsNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/community-guidelines'
    | '/help'
    | '/not-found'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/admin'
    | '/join-a-circle'
    | '/start-a-circle'
    | '/auth/finishing'
    | '/auth/login'
    | '/auth/password-reset'
    | '/auth/signup'
    | '/auth/sso-callback'
    | '/invites/$token'
    | '/onboarding/build-skills'
    | '/onboarding/circles'
    | '/onboarding/complete'
    | '/onboarding/get-involved'
    | '/onboarding/profile'
    | '/onboarding/welcome'
    | '/circles/new'
    | '/groups/new'
    | '/members/$id'
    | '/networks/create'
    | '/networks/new'
    | '/posts/$id'
    | '/profile/me'
    | '/get-started'
    | '/join-us'
    | '/sign-in'
    | '/join-a-network/$slug'
    | '/join/$slug'
    | '/onboarding/cl/complete'
    | '/onboarding/cl/create-circle'
    | '/onboarding/cl/welcome'
    | '/onboarding/cm/build-skills'
    | '/onboarding/cm/complete'
    | '/onboarding/cm/connect'
    | '/onboarding/cm/find-circle'
    | '/onboarding/cm/welcome'
    | '/onboarding/j/about'
    | '/onboarding/j/circle'
    | '/onboarding/j/youre-in'
    | '/onboarding/nl/access-network'
    | '/onboarding/nl/complete'
    | '/onboarding/nl/hub'
    | '/onboarding/nl/manage-network'
    | '/onboarding/nl/network-page'
    | '/onboarding/nl/welcome'
    | '/admin/'
    | '/coach/'
    | '/directory/'
    | '/events/'
    | '/feed/'
    | '/groups/'
    | '/invitations/'
    | '/messages/'
    | '/notifications/'
    | '/people/'
    | '/profile/'
    | '/roadmap/'
    | '/search/'
    | '/settings/'
    | '/circles/'
    | '/join-a-network/'
    | '/join/'
    | '/networks/'
    | '/resources/'
    | '/admin/members/$userId'
    | '/admin/moderation/$reportId'
    | '/admin/roadmap/$itemId'
    | '/admin/topics/$topicId'
    | '/circles/$id/admin'
    | '/circles/$id/edit'
    | '/groups/$id/admin'
    | '/networks/$id/admin'
    | '/admin/broadcasts/'
    | '/admin/coach/'
    | '/admin/dsr/'
    | '/admin/feature-flags/'
    | '/admin/invitations/'
    | '/admin/members/'
    | '/admin/moderation/'
    | '/admin/resources/'
    | '/admin/roadmap/'
    | '/admin/topics/'
    | '/admin/user-research/'
    | '/events/$id/'
    | '/events/new/'
    | '/groups/$id/'
    | '/moderation/contest/'
    | '/settings/account/'
    | '/settings/connected/'
    | '/settings/dsr/'
    | '/settings/email/'
    | '/settings/notifications/'
    | '/settings/privacy/'
    | '/settings/sessions/'
    | '/circles/$id/'
    | '/networks/$id/'
    | '/resources/$id/'
    | '/admin/broadcasts/$id/edit'
    | '/admin/broadcasts/$id/'
    | '/admin/broadcasts/new/'
    | '/admin/invitations/bulk/'
    | '/admin/invitations/new/'
    | '/admin/resources/$id/'
    | '/admin/resources/new/'
    | '/circles/$id/admin/'
    | '/events/$id/edit/'
    | '/groups/$id/admin/'
    | '/moderation/auto-hide-notice/$holdId/'
    | '/moderation/contest/$contestationId/'
    | '/networks/$id/admin/'
    | '/settings/privacy/blocked/'
    | '/resources/learning-tracks/$trackId/'
    | '/admin/resources/$id/edit/'
    | '/admin/resources/learning-tracks/$trackId/'
    | '/circles/$id/admin/broadcasts/$broadcastId/edit'
    | '/groups/$id/admin/broadcasts/$broadcastId/edit'
    | '/networks/$id/admin/broadcasts/$broadcastId/edit'
    | '/circles/$id/admin/broadcasts/$broadcastId/'
    | '/circles/$id/admin/broadcasts/new/'
    | '/groups/$id/admin/broadcasts/$broadcastId/'
    | '/groups/$id/admin/broadcasts/new/'
    | '/networks/$id/admin/broadcasts/$broadcastId/'
    | '/networks/$id/admin/broadcasts/new/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/community-guidelines'
    | '/help'
    | '/not-found'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/join-a-circle'
    | '/start-a-circle'
    | '/auth/finishing'
    | '/auth/login'
    | '/auth/password-reset'
    | '/auth/signup'
    | '/auth/sso-callback'
    | '/invites/$token'
    | '/onboarding/build-skills'
    | '/onboarding/circles'
    | '/onboarding/complete'
    | '/onboarding/get-involved'
    | '/onboarding/profile'
    | '/onboarding/welcome'
    | '/circles/new'
    | '/groups/new'
    | '/members/$id'
    | '/networks/create'
    | '/networks/new'
    | '/posts/$id'
    | '/profile/me'
    | '/get-started'
    | '/join-us'
    | '/sign-in'
    | '/join-a-network/$slug'
    | '/join/$slug'
    | '/onboarding/cl/complete'
    | '/onboarding/cl/create-circle'
    | '/onboarding/cl/welcome'
    | '/onboarding/cm/build-skills'
    | '/onboarding/cm/complete'
    | '/onboarding/cm/connect'
    | '/onboarding/cm/find-circle'
    | '/onboarding/cm/welcome'
    | '/onboarding/j/about'
    | '/onboarding/j/circle'
    | '/onboarding/j/youre-in'
    | '/onboarding/nl/access-network'
    | '/onboarding/nl/complete'
    | '/onboarding/nl/hub'
    | '/onboarding/nl/manage-network'
    | '/onboarding/nl/network-page'
    | '/onboarding/nl/welcome'
    | '/admin'
    | '/coach'
    | '/directory'
    | '/events'
    | '/feed'
    | '/groups'
    | '/invitations'
    | '/messages'
    | '/notifications'
    | '/people'
    | '/profile'
    | '/roadmap'
    | '/search'
    | '/settings'
    | '/circles'
    | '/join-a-network'
    | '/join'
    | '/networks'
    | '/resources'
    | '/admin/members/$userId'
    | '/admin/moderation/$reportId'
    | '/admin/roadmap/$itemId'
    | '/admin/topics/$topicId'
    | '/circles/$id/edit'
    | '/admin/broadcasts'
    | '/admin/coach'
    | '/admin/dsr'
    | '/admin/feature-flags'
    | '/admin/invitations'
    | '/admin/members'
    | '/admin/moderation'
    | '/admin/resources'
    | '/admin/roadmap'
    | '/admin/topics'
    | '/admin/user-research'
    | '/events/$id'
    | '/events/new'
    | '/groups/$id'
    | '/moderation/contest'
    | '/settings/account'
    | '/settings/connected'
    | '/settings/dsr'
    | '/settings/email'
    | '/settings/notifications'
    | '/settings/privacy'
    | '/settings/sessions'
    | '/circles/$id'
    | '/networks/$id'
    | '/resources/$id'
    | '/admin/broadcasts/$id/edit'
    | '/admin/broadcasts/$id'
    | '/admin/broadcasts/new'
    | '/admin/invitations/bulk'
    | '/admin/invitations/new'
    | '/admin/resources/$id'
    | '/admin/resources/new'
    | '/circles/$id/admin'
    | '/events/$id/edit'
    | '/groups/$id/admin'
    | '/moderation/auto-hide-notice/$holdId'
    | '/moderation/contest/$contestationId'
    | '/networks/$id/admin'
    | '/settings/privacy/blocked'
    | '/resources/learning-tracks/$trackId'
    | '/admin/resources/$id/edit'
    | '/admin/resources/learning-tracks/$trackId'
    | '/circles/$id/admin/broadcasts/$broadcastId/edit'
    | '/groups/$id/admin/broadcasts/$broadcastId/edit'
    | '/networks/$id/admin/broadcasts/$broadcastId/edit'
    | '/circles/$id/admin/broadcasts/$broadcastId'
    | '/circles/$id/admin/broadcasts/new'
    | '/groups/$id/admin/broadcasts/$broadcastId'
    | '/groups/$id/admin/broadcasts/new'
    | '/networks/$id/admin/broadcasts/$broadcastId'
    | '/networks/$id/admin/broadcasts/new'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/_public'
    | '/auth'
    | '/community-guidelines'
    | '/help'
    | '/not-found'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/_authed/admin'
    | '/_public/_landing'
    | '/_public/join-a-circle'
    | '/_public/start-a-circle'
    | '/auth/finishing'
    | '/auth/login'
    | '/auth/password-reset'
    | '/auth/signup'
    | '/auth/sso-callback'
    | '/invites/$token'
    | '/onboarding/build-skills'
    | '/onboarding/circles'
    | '/onboarding/complete'
    | '/onboarding/get-involved'
    | '/onboarding/profile'
    | '/onboarding/welcome'
    | '/_authed/circles/new'
    | '/_authed/groups/new'
    | '/_authed/members/$id'
    | '/_authed/networks/create'
    | '/_authed/networks/new'
    | '/_authed/posts/$id'
    | '/_authed/profile/me'
    | '/_public/_landing/get-started'
    | '/_public/_landing/join-us'
    | '/_public/_landing/sign-in'
    | '/_public/join-a-network/$slug'
    | '/_public/join/$slug'
    | '/onboarding/cl/complete'
    | '/onboarding/cl/create-circle'
    | '/onboarding/cl/welcome'
    | '/onboarding/cm/build-skills'
    | '/onboarding/cm/complete'
    | '/onboarding/cm/connect'
    | '/onboarding/cm/find-circle'
    | '/onboarding/cm/welcome'
    | '/onboarding/j/about'
    | '/onboarding/j/circle'
    | '/onboarding/j/youre-in'
    | '/onboarding/nl/access-network'
    | '/onboarding/nl/complete'
    | '/onboarding/nl/hub'
    | '/onboarding/nl/manage-network'
    | '/onboarding/nl/network-page'
    | '/onboarding/nl/welcome'
    | '/_authed/admin/'
    | '/_authed/coach/'
    | '/_authed/directory/'
    | '/_authed/events/'
    | '/_authed/feed/'
    | '/_authed/groups/'
    | '/_authed/invitations/'
    | '/_authed/messages/'
    | '/_authed/notifications/'
    | '/_authed/people/'
    | '/_authed/profile/'
    | '/_authed/roadmap/'
    | '/_authed/search/'
    | '/_authed/settings/'
    | '/_public/circles/'
    | '/_public/join-a-network/'
    | '/_public/join/'
    | '/_public/networks/'
    | '/_public/resources/'
    | '/_authed/admin/members/$userId'
    | '/_authed/admin/moderation/$reportId'
    | '/_authed/admin/roadmap/$itemId'
    | '/_authed/admin/topics/$topicId'
    | '/_authed/circles/$id/admin'
    | '/_authed/circles/$id/edit'
    | '/_authed/groups/$id/admin'
    | '/_authed/networks/$id/admin'
    | '/_authed/admin/broadcasts/'
    | '/_authed/admin/coach/'
    | '/_authed/admin/dsr/'
    | '/_authed/admin/feature-flags/'
    | '/_authed/admin/invitations/'
    | '/_authed/admin/members/'
    | '/_authed/admin/moderation/'
    | '/_authed/admin/resources/'
    | '/_authed/admin/roadmap/'
    | '/_authed/admin/topics/'
    | '/_authed/admin/user-research/'
    | '/_authed/events/$id/'
    | '/_authed/events/new/'
    | '/_authed/groups/$id/'
    | '/_authed/moderation/contest/'
    | '/_authed/settings/account/'
    | '/_authed/settings/connected/'
    | '/_authed/settings/dsr/'
    | '/_authed/settings/email/'
    | '/_authed/settings/notifications/'
    | '/_authed/settings/privacy/'
    | '/_authed/settings/sessions/'
    | '/_public/circles/$id/'
    | '/_public/networks/$id/'
    | '/_public/resources/$id/'
    | '/_authed/admin/broadcasts/$id/edit'
    | '/_authed/admin/broadcasts/$id/'
    | '/_authed/admin/broadcasts/new/'
    | '/_authed/admin/invitations/bulk/'
    | '/_authed/admin/invitations/new/'
    | '/_authed/admin/resources/$id/'
    | '/_authed/admin/resources/new/'
    | '/_authed/circles/$id/admin/'
    | '/_authed/events/$id/edit/'
    | '/_authed/groups/$id/admin/'
    | '/_authed/moderation/auto-hide-notice/$holdId/'
    | '/_authed/moderation/contest/$contestationId/'
    | '/_authed/networks/$id/admin/'
    | '/_authed/settings/privacy/blocked/'
    | '/_public/resources/learning-tracks/$trackId/'
    | '/_authed/admin/resources/$id/edit/'
    | '/_authed/admin/resources/learning-tracks/$trackId/'
    | '/_authed/circles/$id/admin/broadcasts/$broadcastId/edit'
    | '/_authed/groups/$id/admin/broadcasts/$broadcastId/edit'
    | '/_authed/networks/$id/admin/broadcasts/$broadcastId/edit'
    | '/_authed/circles/$id/admin/broadcasts/$broadcastId/'
    | '/_authed/circles/$id/admin/broadcasts/new/'
    | '/_authed/groups/$id/admin/broadcasts/$broadcastId/'
    | '/_authed/groups/$id/admin/broadcasts/new/'
    | '/_authed/networks/$id/admin/broadcasts/$broadcastId/'
    | '/_authed/networks/$id/admin/broadcasts/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  CommunityGuidelinesRoute: typeof CommunityGuidelinesRoute
  HelpRoute: typeof HelpRoute
  NotFoundRoute: typeof NotFoundRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  InvitesTokenRoute: typeof InvitesTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community-guidelines': {
      id: '/community-guidelines'
      path: '/community-guidelines'
      fullPath: '/community-guidelines'
      preLoaderRoute: typeof CommunityGuidelinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/_landing': {
      id: '/_public/_landing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicLandingRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/join-a-circle': {
      id: '/_public/join-a-circle'
      path: '/join-a-circle'
      fullPath: '/join-a-circle'
      preLoaderRoute: typeof PublicJoinACircleRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/start-a-circle': {
      id: '/_public/start-a-circle'
      path: '/start-a-circle'
      fullPath: '/start-a-circle'
      preLoaderRoute: typeof PublicStartACircleRouteImport
      parentRoute: typeof PublicRoute
    }
    '/auth/finishing': {
      id: '/auth/finishing'
      path: '/finishing'
      fullPath: '/auth/finishing'
      preLoaderRoute: typeof AuthFinishingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/sso-callback': {
      id: '/auth/sso-callback'
      path: '/sso-callback'
      fullPath: '/auth/sso-callback'
      preLoaderRoute: typeof AuthSsoCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/invites/$token': {
      id: '/invites/$token'
      path: '/invites/$token'
      fullPath: '/invites/$token'
      preLoaderRoute: typeof InvitesTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/build-skills': {
      id: '/onboarding/build-skills'
      path: '/build-skills'
      fullPath: '/onboarding/build-skills'
      preLoaderRoute: typeof OnboardingBuildSkillsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/circles': {
      id: '/onboarding/circles'
      path: '/circles'
      fullPath: '/onboarding/circles'
      preLoaderRoute: typeof OnboardingCirclesRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/complete': {
      id: '/onboarding/complete'
      path: '/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof OnboardingCompleteRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/get-involved': {
      id: '/onboarding/get-involved'
      path: '/get-involved'
      fullPath: '/onboarding/get-involved'
      preLoaderRoute: typeof OnboardingGetInvolvedRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/profile': {
      id: '/onboarding/profile'
      path: '/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof OnboardingProfileRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/circles/new': {
      id: '/_authed/circles/new'
      path: '/circles/new'
      fullPath: '/circles/new'
      preLoaderRoute: typeof AuthedCirclesNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/coach/': {
      id: '/_authed/coach/'
      path: '/coach'
      fullPath: '/coach/'
      preLoaderRoute: typeof AuthedCoachIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/directory/': {
      id: '/_authed/directory/'
      path: '/directory'
      fullPath: '/directory/'
      preLoaderRoute: typeof AuthedDirectoryIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/events/': {
      id: '/_authed/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthedEventsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/feed/': {
      id: '/_authed/feed/'
      path: '/feed'
      fullPath: '/feed/'
      preLoaderRoute: typeof AuthedFeedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/groups/': {
      id: '/_authed/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AuthedGroupsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/groups/new': {
      id: '/_authed/groups/new'
      path: '/groups/new'
      fullPath: '/groups/new'
      preLoaderRoute: typeof AuthedGroupsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invitations/': {
      id: '/_authed/invitations/'
      path: '/invitations'
      fullPath: '/invitations/'
      preLoaderRoute: typeof AuthedInvitationsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/members/$id': {
      id: '/_authed/members/$id'
      path: '/members/$id'
      fullPath: '/members/$id'
      preLoaderRoute: typeof AuthedMembersIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/messages/': {
      id: '/_authed/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof AuthedMessagesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/networks/create': {
      id: '/_authed/networks/create'
      path: '/networks/create'
      fullPath: '/networks/create'
      preLoaderRoute: typeof AuthedNetworksCreateRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/networks/new': {
      id: '/_authed/networks/new'
      path: '/networks/new'
      fullPath: '/networks/new'
      preLoaderRoute: typeof AuthedNetworksNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/notifications/': {
      id: '/_authed/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthedNotificationsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/people/': {
      id: '/_authed/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AuthedPeopleIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/posts/$id': {
      id: '/_authed/posts/$id'
      path: '/posts/$id'
      fullPath: '/posts/$id'
      preLoaderRoute: typeof AuthedPostsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile/': {
      id: '/_authed/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthedProfileIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile/me': {
      id: '/_authed/profile/me'
      path: '/profile/me'
      fullPath: '/profile/me'
      preLoaderRoute: typeof AuthedProfileMeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/roadmap/': {
      id: '/_authed/roadmap/'
      path: '/roadmap'
      fullPath: '/roadmap/'
      preLoaderRoute: typeof AuthedRoadmapIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/search/': {
      id: '/_authed/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AuthedSearchIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedSettingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/_landing/get-started': {
      id: '/_public/_landing/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof PublicLandingGetStartedRouteImport
      parentRoute: typeof PublicLandingRoute
    }
    '/_public/_landing/join-us': {
      id: '/_public/_landing/join-us'
      path: '/join-us'
      fullPath: '/join-us'
      preLoaderRoute: typeof PublicLandingJoinUsRouteImport
      parentRoute: typeof PublicLandingRoute
    }
    '/_public/_landing/sign-in': {
      id: '/_public/_landing/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicLandingSignInRouteImport
      parentRoute: typeof PublicLandingRoute
    }
    '/_public/circles/': {
      id: '/_public/circles/'
      path: '/circles'
      fullPath: '/circles/'
      preLoaderRoute: typeof PublicCirclesIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/join-a-network/': {
      id: '/_public/join-a-network/'
      path: '/join-a-network'
      fullPath: '/join-a-network/'
      preLoaderRoute: typeof PublicJoinANetworkIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/join-a-network/$slug': {
      id: '/_public/join-a-network/$slug'
      path: '/join-a-network/$slug'
      fullPath: '/join-a-network/$slug'
      preLoaderRoute: typeof PublicJoinANetworkSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/join/': {
      id: '/_public/join/'
      path: '/join'
      fullPath: '/join/'
      preLoaderRoute: typeof PublicJoinIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/join/$slug': {
      id: '/_public/join/$slug'
      path: '/join/$slug'
      fullPath: '/join/$slug'
      preLoaderRoute: typeof PublicJoinSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/networks/': {
      id: '/_public/networks/'
      path: '/networks'
      fullPath: '/networks/'
      preLoaderRoute: typeof PublicNetworksIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/resources/': {
      id: '/_public/resources/'
      path: '/resources'
      fullPath: '/resources/'
      preLoaderRoute: typeof PublicResourcesIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/onboarding/cl/complete': {
      id: '/onboarding/cl/complete'
      path: '/cl/complete'
      fullPath: '/onboarding/cl/complete'
      preLoaderRoute: typeof OnboardingClCompleteRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/cl/create-circle': {
      id: '/onboarding/cl/create-circle'
      path: '/cl/create-circle'
      fullPath: '/onboarding/cl/create-circle'
      preLoaderRoute: typeof OnboardingClCreateCircleRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/cl/welcome': {
      id: '/onboarding/cl/welcome'
      path: '/cl/welcome'
      fullPath: '/onboarding/cl/welcome'
      preLoaderRoute: typeof OnboardingClWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/cm/build-skills': {
      id: '/onboarding/cm/build-skills'
      path: '/cm/build-skills'
      fullPath: '/onboarding/cm/build-skills'
      preLoaderRoute: typeof OnboardingCmBuildSkillsRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/cm/complete': {
      id: '/onboarding/cm/complete'
      path: '/cm/complete'
      fullPath: '/onboarding/cm/complete'
      preLoaderRoute: typeof OnboardingCmCompleteRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/cm/connect': {
      id: '/onboarding/cm/connect'
      path: '/cm/connect'
      fullPath: '/onboarding/cm/connect'
      preLoaderRoute: typeof OnboardingCmConnectRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/cm/find-circle': {
      id: '/onboarding/cm/find-circle'
      path: '/cm/find-circle'
      fullPath: '/onboarding/cm/find-circle'
      preLoaderRoute: typeof OnboardingCmFindCircleRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/cm/welcome': {
      id: '/onboarding/cm/welcome'
      path: '/cm/welcome'
      fullPath: '/onboarding/cm/welcome'
      preLoaderRoute: typeof OnboardingCmWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/j/about': {
      id: '/onboarding/j/about'
      path: '/j/about'
      fullPath: '/onboarding/j/about'
      preLoaderRoute: typeof OnboardingJAboutRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/j/circle': {
      id: '/onboarding/j/circle'
      path: '/j/circle'
      fullPath: '/onboarding/j/circle'
      preLoaderRoute: typeof OnboardingJCircleRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/j/youre-in': {
      id: '/onboarding/j/youre-in'
      path: '/j/youre-in'
      fullPath: '/onboarding/j/youre-in'
      preLoaderRoute: typeof OnboardingJYoureInRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/nl/access-network': {
      id: '/onboarding/nl/access-network'
      path: '/nl/access-network'
      fullPath: '/onboarding/nl/access-network'
      preLoaderRoute: typeof OnboardingNlAccessNetworkRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/nl/complete': {
      id: '/onboarding/nl/complete'
      path: '/nl/complete'
      fullPath: '/onboarding/nl/complete'
      preLoaderRoute: typeof OnboardingNlCompleteRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/nl/hub': {
      id: '/onboarding/nl/hub'
      path: '/nl/hub'
      fullPath: '/onboarding/nl/hub'
      preLoaderRoute: typeof OnboardingNlHubRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/nl/manage-network': {
      id: '/onboarding/nl/manage-network'
      path: '/nl/manage-network'
      fullPath: '/onboarding/nl/manage-network'
      preLoaderRoute: typeof OnboardingNlManageNetworkRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/nl/network-page': {
      id: '/onboarding/nl/network-page'
      path: '/nl/network-page'
      fullPath: '/onboarding/nl/network-page'
      preLoaderRoute: typeof OnboardingNlNetworkPageRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/nl/welcome': {
      id: '/onboarding/nl/welcome'
      path: '/nl/welcome'
      fullPath: '/onboarding/nl/welcome'
      preLoaderRoute: typeof OnboardingNlWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_authed/admin/broadcasts/': {
      id: '/_authed/admin/broadcasts/'
      path: '/broadcasts'
      fullPath: '/admin/broadcasts/'
      preLoaderRoute: typeof AuthedAdminBroadcastsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/coach/': {
      id: '/_authed/admin/coach/'
      path: '/coach'
      fullPath: '/admin/coach/'
      preLoaderRoute: typeof AuthedAdminCoachIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/dsr/': {
      id: '/_authed/admin/dsr/'
      path: '/dsr'
      fullPath: '/admin/dsr/'
      preLoaderRoute: typeof AuthedAdminDsrIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/feature-flags/': {
      id: '/_authed/admin/feature-flags/'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags/'
      preLoaderRoute: typeof AuthedAdminFeatureFlagsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/invitations/': {
      id: '/_authed/admin/invitations/'
      path: '/invitations'
      fullPath: '/admin/invitations/'
      preLoaderRoute: typeof AuthedAdminInvitationsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/members/': {
      id: '/_authed/admin/members/'
      path: '/members'
      fullPath: '/admin/members/'
      preLoaderRoute: typeof AuthedAdminMembersIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/members/$userId': {
      id: '/_authed/admin/members/$userId'
      path: '/members/$userId'
      fullPath: '/admin/members/$userId'
      preLoaderRoute: typeof AuthedAdminMembersUserIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/moderation/': {
      id: '/_authed/admin/moderation/'
      path: '/moderation'
      fullPath: '/admin/moderation/'
      preLoaderRoute: typeof AuthedAdminModerationIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/moderation/$reportId': {
      id: '/_authed/admin/moderation/$reportId'
      path: '/moderation/$reportId'
      fullPath: '/admin/moderation/$reportId'
      preLoaderRoute: typeof AuthedAdminModerationReportIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/resources/': {
      id: '/_authed/admin/resources/'
      path: '/resources'
      fullPath: '/admin/resources/'
      preLoaderRoute: typeof AuthedAdminResourcesIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/roadmap/': {
      id: '/_authed/admin/roadmap/'
      path: '/roadmap'
      fullPath: '/admin/roadmap/'
      preLoaderRoute: typeof AuthedAdminRoadmapIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/roadmap/$itemId': {
      id: '/_authed/admin/roadmap/$itemId'
      path: '/roadmap/$itemId'
      fullPath: '/admin/roadmap/$itemId'
      preLoaderRoute: typeof AuthedAdminRoadmapItemIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/topics/': {
      id: '/_authed/admin/topics/'
      path: '/topics'
      fullPath: '/admin/topics/'
      preLoaderRoute: typeof AuthedAdminTopicsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/topics/$topicId': {
      id: '/_authed/admin/topics/$topicId'
      path: '/topics/$topicId'
      fullPath: '/admin/topics/$topicId'
      preLoaderRoute: typeof AuthedAdminTopicsTopicIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/user-research/': {
      id: '/_authed/admin/user-research/'
      path: '/user-research'
      fullPath: '/admin/user-research/'
      preLoaderRoute: typeof AuthedAdminUserResearchIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/circles/$id/admin': {
      id: '/_authed/circles/$id/admin'
      path: '/circles/$id/admin'
      fullPath: '/circles/$id/admin'
      preLoaderRoute: typeof AuthedCirclesIdAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/circles/$id/edit': {
      id: '/_authed/circles/$id/edit'
      path: '/circles/$id/edit'
      fullPath: '/circles/$id/edit'
      preLoaderRoute: typeof AuthedCirclesIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/events/$id/': {
      id: '/_authed/events/$id/'
      path: '/events/$id'
      fullPath: '/events/$id/'
      preLoaderRoute: typeof AuthedEventsIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/events/new/': {
      id: '/_authed/events/new/'
      path: '/events/new'
      fullPath: '/events/new/'
      preLoaderRoute: typeof AuthedEventsNewIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/groups/$id/': {
      id: '/_authed/groups/$id/'
      path: '/groups/$id'
      fullPath: '/groups/$id/'
      preLoaderRoute: typeof AuthedGroupsIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/groups/$id/admin': {
      id: '/_authed/groups/$id/admin'
      path: '/groups/$id/admin'
      fullPath: '/groups/$id/admin'
      preLoaderRoute: typeof AuthedGroupsIdAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/moderation/contest/': {
      id: '/_authed/moderation/contest/'
      path: '/moderation/contest'
      fullPath: '/moderation/contest/'
      preLoaderRoute: typeof AuthedModerationContestIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/networks/$id/admin': {
      id: '/_authed/networks/$id/admin'
      path: '/networks/$id/admin'
      fullPath: '/networks/$id/admin'
      preLoaderRoute: typeof AuthedNetworksIdAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/account/': {
      id: '/_authed/settings/account/'
      path: '/settings/account'
      fullPath: '/settings/account/'
      preLoaderRoute: typeof AuthedSettingsAccountIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/connected/': {
      id: '/_authed/settings/connected/'
      path: '/settings/connected'
      fullPath: '/settings/connected/'
      preLoaderRoute: typeof AuthedSettingsConnectedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/dsr/': {
      id: '/_authed/settings/dsr/'
      path: '/settings/dsr'
      fullPath: '/settings/dsr/'
      preLoaderRoute: typeof AuthedSettingsDsrIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/email/': {
      id: '/_authed/settings/email/'
      path: '/settings/email'
      fullPath: '/settings/email/'
      preLoaderRoute: typeof AuthedSettingsEmailIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/notifications/': {
      id: '/_authed/settings/notifications/'
      path: '/settings/notifications'
      fullPath: '/settings/notifications/'
      preLoaderRoute: typeof AuthedSettingsNotificationsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/privacy/': {
      id: '/_authed/settings/privacy/'
      path: '/settings/privacy'
      fullPath: '/settings/privacy/'
      preLoaderRoute: typeof AuthedSettingsPrivacyIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/sessions/': {
      id: '/_authed/settings/sessions/'
      path: '/settings/sessions'
      fullPath: '/settings/sessions/'
      preLoaderRoute: typeof AuthedSettingsSessionsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/circles/$id/': {
      id: '/_public/circles/$id/'
      path: '/circles/$id'
      fullPath: '/circles/$id/'
      preLoaderRoute: typeof PublicCirclesIdIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/networks/$id/': {
      id: '/_public/networks/$id/'
      path: '/networks/$id'
      fullPath: '/networks/$id/'
      preLoaderRoute: typeof PublicNetworksIdIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/resources/$id/': {
      id: '/_public/resources/$id/'
      path: '/resources/$id'
      fullPath: '/resources/$id/'
      preLoaderRoute: typeof PublicResourcesIdIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/admin/broadcasts/$id/': {
      id: '/_authed/admin/broadcasts/$id/'
      path: '/broadcasts/$id'
      fullPath: '/admin/broadcasts/$id/'
      preLoaderRoute: typeof AuthedAdminBroadcastsIdIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/broadcasts/$id/edit': {
      id: '/_authed/admin/broadcasts/$id/edit'
      path: '/broadcasts/$id/edit'
      fullPath: '/admin/broadcasts/$id/edit'
      preLoaderRoute: typeof AuthedAdminBroadcastsIdEditRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/broadcasts/new/': {
      id: '/_authed/admin/broadcasts/new/'
      path: '/broadcasts/new'
      fullPath: '/admin/broadcasts/new/'
      preLoaderRoute: typeof AuthedAdminBroadcastsNewIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/invitations/bulk/': {
      id: '/_authed/admin/invitations/bulk/'
      path: '/invitations/bulk'
      fullPath: '/admin/invitations/bulk/'
      preLoaderRoute: typeof AuthedAdminInvitationsBulkIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/invitations/new/': {
      id: '/_authed/admin/invitations/new/'
      path: '/invitations/new'
      fullPath: '/admin/invitations/new/'
      preLoaderRoute: typeof AuthedAdminInvitationsNewIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/resources/$id/': {
      id: '/_authed/admin/resources/$id/'
      path: '/resources/$id'
      fullPath: '/admin/resources/$id/'
      preLoaderRoute: typeof AuthedAdminResourcesIdIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/resources/new/': {
      id: '/_authed/admin/resources/new/'
      path: '/resources/new'
      fullPath: '/admin/resources/new/'
      preLoaderRoute: typeof AuthedAdminResourcesNewIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/circles/$id/admin/': {
      id: '/_authed/circles/$id/admin/'
      path: '/'
      fullPath: '/circles/$id/admin/'
      preLoaderRoute: typeof AuthedCirclesIdAdminIndexRouteImport
      parentRoute: typeof AuthedCirclesIdAdminRoute
    }
    '/_authed/events/$id/edit/': {
      id: '/_authed/events/$id/edit/'
      path: '/events/$id/edit'
      fullPath: '/events/$id/edit/'
      preLoaderRoute: typeof AuthedEventsIdEditIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/groups/$id/admin/': {
      id: '/_authed/groups/$id/admin/'
      path: '/'
      fullPath: '/groups/$id/admin/'
      preLoaderRoute: typeof AuthedGroupsIdAdminIndexRouteImport
      parentRoute: typeof AuthedGroupsIdAdminRoute
    }
    '/_authed/moderation/auto-hide-notice/$holdId/': {
      id: '/_authed/moderation/auto-hide-notice/$holdId/'
      path: '/moderation/auto-hide-notice/$holdId'
      fullPath: '/moderation/auto-hide-notice/$holdId/'
      preLoaderRoute: typeof AuthedModerationAutoHideNoticeHoldIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/moderation/contest/$contestationId/': {
      id: '/_authed/moderation/contest/$contestationId/'
      path: '/moderation/contest/$contestationId'
      fullPath: '/moderation/contest/$contestationId/'
      preLoaderRoute: typeof AuthedModerationContestContestationIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/networks/$id/admin/': {
      id: '/_authed/networks/$id/admin/'
      path: '/'
      fullPath: '/networks/$id/admin/'
      preLoaderRoute: typeof AuthedNetworksIdAdminIndexRouteImport
      parentRoute: typeof AuthedNetworksIdAdminRoute
    }
    '/_authed/settings/privacy/blocked/': {
      id: '/_authed/settings/privacy/blocked/'
      path: '/settings/privacy/blocked'
      fullPath: '/settings/privacy/blocked/'
      preLoaderRoute: typeof AuthedSettingsPrivacyBlockedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/resources/learning-tracks/$trackId/': {
      id: '/_public/resources/learning-tracks/$trackId/'
      path: '/resources/learning-tracks/$trackId'
      fullPath: '/resources/learning-tracks/$trackId/'
      preLoaderRoute: typeof PublicResourcesLearningTracksTrackIdIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/admin/resources/$id/edit/': {
      id: '/_authed/admin/resources/$id/edit/'
      path: '/resources/$id/edit'
      fullPath: '/admin/resources/$id/edit/'
      preLoaderRoute: typeof AuthedAdminResourcesIdEditIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/resources/learning-tracks/$trackId/': {
      id: '/_authed/admin/resources/learning-tracks/$trackId/'
      path: '/resources/learning-tracks/$trackId'
      fullPath: '/admin/resources/learning-tracks/$trackId/'
      preLoaderRoute: typeof AuthedAdminResourcesLearningTracksTrackIdIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/circles/$id/admin/broadcasts/$broadcastId/': {
      id: '/_authed/circles/$id/admin/broadcasts/$broadcastId/'
      path: '/broadcasts/$broadcastId'
      fullPath: '/circles/$id/admin/broadcasts/$broadcastId/'
      preLoaderRoute: typeof AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRouteImport
      parentRoute: typeof AuthedCirclesIdAdminRoute
    }
    '/_authed/circles/$id/admin/broadcasts/$broadcastId/edit': {
      id: '/_authed/circles/$id/admin/broadcasts/$broadcastId/edit'
      path: '/broadcasts/$broadcastId/edit'
      fullPath: '/circles/$id/admin/broadcasts/$broadcastId/edit'
      preLoaderRoute: typeof AuthedCirclesIdAdminBroadcastsBroadcastIdEditRouteImport
      parentRoute: typeof AuthedCirclesIdAdminRoute
    }
    '/_authed/circles/$id/admin/broadcasts/new/': {
      id: '/_authed/circles/$id/admin/broadcasts/new/'
      path: '/broadcasts/new'
      fullPath: '/circles/$id/admin/broadcasts/new/'
      preLoaderRoute: typeof AuthedCirclesIdAdminBroadcastsNewIndexRouteImport
      parentRoute: typeof AuthedCirclesIdAdminRoute
    }
    '/_authed/groups/$id/admin/broadcasts/$broadcastId/': {
      id: '/_authed/groups/$id/admin/broadcasts/$broadcastId/'
      path: '/broadcasts/$broadcastId'
      fullPath: '/groups/$id/admin/broadcasts/$broadcastId/'
      preLoaderRoute: typeof AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRouteImport
      parentRoute: typeof AuthedGroupsIdAdminRoute
    }
    '/_authed/groups/$id/admin/broadcasts/$broadcastId/edit': {
      id: '/_authed/groups/$id/admin/broadcasts/$broadcastId/edit'
      path: '/broadcasts/$broadcastId/edit'
      fullPath: '/groups/$id/admin/broadcasts/$broadcastId/edit'
      preLoaderRoute: typeof AuthedGroupsIdAdminBroadcastsBroadcastIdEditRouteImport
      parentRoute: typeof AuthedGroupsIdAdminRoute
    }
    '/_authed/groups/$id/admin/broadcasts/new/': {
      id: '/_authed/groups/$id/admin/broadcasts/new/'
      path: '/broadcasts/new'
      fullPath: '/groups/$id/admin/broadcasts/new/'
      preLoaderRoute: typeof AuthedGroupsIdAdminBroadcastsNewIndexRouteImport
      parentRoute: typeof AuthedGroupsIdAdminRoute
    }
    '/_authed/networks/$id/admin/broadcasts/$broadcastId/': {
      id: '/_authed/networks/$id/admin/broadcasts/$broadcastId/'
      path: '/broadcasts/$broadcastId'
      fullPath: '/networks/$id/admin/broadcasts/$broadcastId/'
      preLoaderRoute: typeof AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRouteImport
      parentRoute: typeof AuthedNetworksIdAdminRoute
    }
    '/_authed/networks/$id/admin/broadcasts/$broadcastId/edit': {
      id: '/_authed/networks/$id/admin/broadcasts/$broadcastId/edit'
      path: '/broadcasts/$broadcastId/edit'
      fullPath: '/networks/$id/admin/broadcasts/$broadcastId/edit'
      preLoaderRoute: typeof AuthedNetworksIdAdminBroadcastsBroadcastIdEditRouteImport
      parentRoute: typeof AuthedNetworksIdAdminRoute
    }
    '/_authed/networks/$id/admin/broadcasts/new/': {
      id: '/_authed/networks/$id/admin/broadcasts/new/'
      path: '/broadcasts/new'
      fullPath: '/networks/$id/admin/broadcasts/new/'
      preLoaderRoute: typeof AuthedNetworksIdAdminBroadcastsNewIndexRouteImport
      parentRoute: typeof AuthedNetworksIdAdminRoute
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedAdminMembersUserIdRoute: typeof AuthedAdminMembersUserIdRoute
  AuthedAdminModerationReportIdRoute: typeof AuthedAdminModerationReportIdRoute
  AuthedAdminRoadmapItemIdRoute: typeof AuthedAdminRoadmapItemIdRoute
  AuthedAdminTopicsTopicIdRoute: typeof AuthedAdminTopicsTopicIdRoute
  AuthedAdminBroadcastsIndexRoute: typeof AuthedAdminBroadcastsIndexRoute
  AuthedAdminCoachIndexRoute: typeof AuthedAdminCoachIndexRoute
  AuthedAdminDsrIndexRoute: typeof AuthedAdminDsrIndexRoute
  AuthedAdminFeatureFlagsIndexRoute: typeof AuthedAdminFeatureFlagsIndexRoute
  AuthedAdminInvitationsIndexRoute: typeof AuthedAdminInvitationsIndexRoute
  AuthedAdminMembersIndexRoute: typeof AuthedAdminMembersIndexRoute
  AuthedAdminModerationIndexRoute: typeof AuthedAdminModerationIndexRoute
  AuthedAdminResourcesIndexRoute: typeof AuthedAdminResourcesIndexRoute
  AuthedAdminRoadmapIndexRoute: typeof AuthedAdminRoadmapIndexRoute
  AuthedAdminTopicsIndexRoute: typeof AuthedAdminTopicsIndexRoute
  AuthedAdminUserResearchIndexRoute: typeof AuthedAdminUserResearchIndexRoute
  AuthedAdminBroadcastsIdEditRoute: typeof AuthedAdminBroadcastsIdEditRoute
  AuthedAdminBroadcastsIdIndexRoute: typeof AuthedAdminBroadcastsIdIndexRoute
  AuthedAdminBroadcastsNewIndexRoute: typeof AuthedAdminBroadcastsNewIndexRoute
  AuthedAdminInvitationsBulkIndexRoute: typeof AuthedAdminInvitationsBulkIndexRoute
  AuthedAdminInvitationsNewIndexRoute: typeof AuthedAdminInvitationsNewIndexRoute
  AuthedAdminResourcesIdIndexRoute: typeof AuthedAdminResourcesIdIndexRoute
  AuthedAdminResourcesNewIndexRoute: typeof AuthedAdminResourcesNewIndexRoute
  AuthedAdminResourcesIdEditIndexRoute: typeof AuthedAdminResourcesIdEditIndexRoute
  AuthedAdminResourcesLearningTracksTrackIdIndexRoute: typeof AuthedAdminResourcesLearningTracksTrackIdIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedAdminMembersUserIdRoute: AuthedAdminMembersUserIdRoute,
  AuthedAdminModerationReportIdRoute: AuthedAdminModerationReportIdRoute,
  AuthedAdminRoadmapItemIdRoute: AuthedAdminRoadmapItemIdRoute,
  AuthedAdminTopicsTopicIdRoute: AuthedAdminTopicsTopicIdRoute,
  AuthedAdminBroadcastsIndexRoute: AuthedAdminBroadcastsIndexRoute,
  AuthedAdminCoachIndexRoute: AuthedAdminCoachIndexRoute,
  AuthedAdminDsrIndexRoute: AuthedAdminDsrIndexRoute,
  AuthedAdminFeatureFlagsIndexRoute: AuthedAdminFeatureFlagsIndexRoute,
  AuthedAdminInvitationsIndexRoute: AuthedAdminInvitationsIndexRoute,
  AuthedAdminMembersIndexRoute: AuthedAdminMembersIndexRoute,
  AuthedAdminModerationIndexRoute: AuthedAdminModerationIndexRoute,
  AuthedAdminResourcesIndexRoute: AuthedAdminResourcesIndexRoute,
  AuthedAdminRoadmapIndexRoute: AuthedAdminRoadmapIndexRoute,
  AuthedAdminTopicsIndexRoute: AuthedAdminTopicsIndexRoute,
  AuthedAdminUserResearchIndexRoute: AuthedAdminUserResearchIndexRoute,
  AuthedAdminBroadcastsIdEditRoute: AuthedAdminBroadcastsIdEditRoute,
  AuthedAdminBroadcastsIdIndexRoute: AuthedAdminBroadcastsIdIndexRoute,
  AuthedAdminBroadcastsNewIndexRoute: AuthedAdminBroadcastsNewIndexRoute,
  AuthedAdminInvitationsBulkIndexRoute: AuthedAdminInvitationsBulkIndexRoute,
  AuthedAdminInvitationsNewIndexRoute: AuthedAdminInvitationsNewIndexRoute,
  AuthedAdminResourcesIdIndexRoute: AuthedAdminResourcesIdIndexRoute,
  AuthedAdminResourcesNewIndexRoute: AuthedAdminResourcesNewIndexRoute,
  AuthedAdminResourcesIdEditIndexRoute: AuthedAdminResourcesIdEditIndexRoute,
  AuthedAdminResourcesLearningTracksTrackIdIndexRoute:
    AuthedAdminResourcesLearningTracksTrackIdIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedCirclesIdAdminRouteChildren {
  AuthedCirclesIdAdminIndexRoute: typeof AuthedCirclesIdAdminIndexRoute
  AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute: typeof AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute
  AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute: typeof AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute
  AuthedCirclesIdAdminBroadcastsNewIndexRoute: typeof AuthedCirclesIdAdminBroadcastsNewIndexRoute
}

const AuthedCirclesIdAdminRouteChildren: AuthedCirclesIdAdminRouteChildren = {
  AuthedCirclesIdAdminIndexRoute: AuthedCirclesIdAdminIndexRoute,
  AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute:
    AuthedCirclesIdAdminBroadcastsBroadcastIdEditRoute,
  AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute:
    AuthedCirclesIdAdminBroadcastsBroadcastIdIndexRoute,
  AuthedCirclesIdAdminBroadcastsNewIndexRoute:
    AuthedCirclesIdAdminBroadcastsNewIndexRoute,
}

const AuthedCirclesIdAdminRouteWithChildren =
  AuthedCirclesIdAdminRoute._addFileChildren(AuthedCirclesIdAdminRouteChildren)

interface AuthedGroupsIdAdminRouteChildren {
  AuthedGroupsIdAdminIndexRoute: typeof AuthedGroupsIdAdminIndexRoute
  AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute: typeof AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute
  AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute: typeof AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute
  AuthedGroupsIdAdminBroadcastsNewIndexRoute: typeof AuthedGroupsIdAdminBroadcastsNewIndexRoute
}

const AuthedGroupsIdAdminRouteChildren: AuthedGroupsIdAdminRouteChildren = {
  AuthedGroupsIdAdminIndexRoute: AuthedGroupsIdAdminIndexRoute,
  AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute:
    AuthedGroupsIdAdminBroadcastsBroadcastIdEditRoute,
  AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute:
    AuthedGroupsIdAdminBroadcastsBroadcastIdIndexRoute,
  AuthedGroupsIdAdminBroadcastsNewIndexRoute:
    AuthedGroupsIdAdminBroadcastsNewIndexRoute,
}

const AuthedGroupsIdAdminRouteWithChildren =
  AuthedGroupsIdAdminRoute._addFileChildren(AuthedGroupsIdAdminRouteChildren)

interface AuthedNetworksIdAdminRouteChildren {
  AuthedNetworksIdAdminIndexRoute: typeof AuthedNetworksIdAdminIndexRoute
  AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute: typeof AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute
  AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute: typeof AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute
  AuthedNetworksIdAdminBroadcastsNewIndexRoute: typeof AuthedNetworksIdAdminBroadcastsNewIndexRoute
}

const AuthedNetworksIdAdminRouteChildren: AuthedNetworksIdAdminRouteChildren = {
  AuthedNetworksIdAdminIndexRoute: AuthedNetworksIdAdminIndexRoute,
  AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute:
    AuthedNetworksIdAdminBroadcastsBroadcastIdEditRoute,
  AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute:
    AuthedNetworksIdAdminBroadcastsBroadcastIdIndexRoute,
  AuthedNetworksIdAdminBroadcastsNewIndexRoute:
    AuthedNetworksIdAdminBroadcastsNewIndexRoute,
}

const AuthedNetworksIdAdminRouteWithChildren =
  AuthedNetworksIdAdminRoute._addFileChildren(
    AuthedNetworksIdAdminRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedCirclesNewRoute: typeof AuthedCirclesNewRoute
  AuthedGroupsNewRoute: typeof AuthedGroupsNewRoute
  AuthedMembersIdRoute: typeof AuthedMembersIdRoute
  AuthedNetworksCreateRoute: typeof AuthedNetworksCreateRoute
  AuthedNetworksNewRoute: typeof AuthedNetworksNewRoute
  AuthedPostsIdRoute: typeof AuthedPostsIdRoute
  AuthedProfileMeRoute: typeof AuthedProfileMeRoute
  AuthedCoachIndexRoute: typeof AuthedCoachIndexRoute
  AuthedDirectoryIndexRoute: typeof AuthedDirectoryIndexRoute
  AuthedEventsIndexRoute: typeof AuthedEventsIndexRoute
  AuthedFeedIndexRoute: typeof AuthedFeedIndexRoute
  AuthedGroupsIndexRoute: typeof AuthedGroupsIndexRoute
  AuthedInvitationsIndexRoute: typeof AuthedInvitationsIndexRoute
  AuthedMessagesIndexRoute: typeof AuthedMessagesIndexRoute
  AuthedNotificationsIndexRoute: typeof AuthedNotificationsIndexRoute
  AuthedPeopleIndexRoute: typeof AuthedPeopleIndexRoute
  AuthedProfileIndexRoute: typeof AuthedProfileIndexRoute
  AuthedRoadmapIndexRoute: typeof AuthedRoadmapIndexRoute
  AuthedSearchIndexRoute: typeof AuthedSearchIndexRoute
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute
  AuthedCirclesIdAdminRoute: typeof AuthedCirclesIdAdminRouteWithChildren
  AuthedCirclesIdEditRoute: typeof AuthedCirclesIdEditRoute
  AuthedGroupsIdAdminRoute: typeof AuthedGroupsIdAdminRouteWithChildren
  AuthedNetworksIdAdminRoute: typeof AuthedNetworksIdAdminRouteWithChildren
  AuthedEventsIdIndexRoute: typeof AuthedEventsIdIndexRoute
  AuthedEventsNewIndexRoute: typeof AuthedEventsNewIndexRoute
  AuthedGroupsIdIndexRoute: typeof AuthedGroupsIdIndexRoute
  AuthedModerationContestIndexRoute: typeof AuthedModerationContestIndexRoute
  AuthedSettingsAccountIndexRoute: typeof AuthedSettingsAccountIndexRoute
  AuthedSettingsConnectedIndexRoute: typeof AuthedSettingsConnectedIndexRoute
  AuthedSettingsDsrIndexRoute: typeof AuthedSettingsDsrIndexRoute
  AuthedSettingsEmailIndexRoute: typeof AuthedSettingsEmailIndexRoute
  AuthedSettingsNotificationsIndexRoute: typeof AuthedSettingsNotificationsIndexRoute
  AuthedSettingsPrivacyIndexRoute: typeof AuthedSettingsPrivacyIndexRoute
  AuthedSettingsSessionsIndexRoute: typeof AuthedSettingsSessionsIndexRoute
  AuthedEventsIdEditIndexRoute: typeof AuthedEventsIdEditIndexRoute
  AuthedModerationAutoHideNoticeHoldIdIndexRoute: typeof AuthedModerationAutoHideNoticeHoldIdIndexRoute
  AuthedModerationContestContestationIdIndexRoute: typeof AuthedModerationContestContestationIdIndexRoute
  AuthedSettingsPrivacyBlockedIndexRoute: typeof AuthedSettingsPrivacyBlockedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedCirclesNewRoute: AuthedCirclesNewRoute,
  AuthedGroupsNewRoute: AuthedGroupsNewRoute,
  AuthedMembersIdRoute: AuthedMembersIdRoute,
  AuthedNetworksCreateRoute: AuthedNetworksCreateRoute,
  AuthedNetworksNewRoute: AuthedNetworksNewRoute,
  AuthedPostsIdRoute: AuthedPostsIdRoute,
  AuthedProfileMeRoute: AuthedProfileMeRoute,
  AuthedCoachIndexRoute: AuthedCoachIndexRoute,
  AuthedDirectoryIndexRoute: AuthedDirectoryIndexRoute,
  AuthedEventsIndexRoute: AuthedEventsIndexRoute,
  AuthedFeedIndexRoute: AuthedFeedIndexRoute,
  AuthedGroupsIndexRoute: AuthedGroupsIndexRoute,
  AuthedInvitationsIndexRoute: AuthedInvitationsIndexRoute,
  AuthedMessagesIndexRoute: AuthedMessagesIndexRoute,
  AuthedNotificationsIndexRoute: AuthedNotificationsIndexRoute,
  AuthedPeopleIndexRoute: AuthedPeopleIndexRoute,
  AuthedProfileIndexRoute: AuthedProfileIndexRoute,
  AuthedRoadmapIndexRoute: AuthedRoadmapIndexRoute,
  AuthedSearchIndexRoute: AuthedSearchIndexRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
  AuthedCirclesIdAdminRoute: AuthedCirclesIdAdminRouteWithChildren,
  AuthedCirclesIdEditRoute: AuthedCirclesIdEditRoute,
  AuthedGroupsIdAdminRoute: AuthedGroupsIdAdminRouteWithChildren,
  AuthedNetworksIdAdminRoute: AuthedNetworksIdAdminRouteWithChildren,
  AuthedEventsIdIndexRoute: AuthedEventsIdIndexRoute,
  AuthedEventsNewIndexRoute: AuthedEventsNewIndexRoute,
  AuthedGroupsIdIndexRoute: AuthedGroupsIdIndexRoute,
  AuthedModerationContestIndexRoute: AuthedModerationContestIndexRoute,
  AuthedSettingsAccountIndexRoute: AuthedSettingsAccountIndexRoute,
  AuthedSettingsConnectedIndexRoute: AuthedSettingsConnectedIndexRoute,
  AuthedSettingsDsrIndexRoute: AuthedSettingsDsrIndexRoute,
  AuthedSettingsEmailIndexRoute: AuthedSettingsEmailIndexRoute,
  AuthedSettingsNotificationsIndexRoute: AuthedSettingsNotificationsIndexRoute,
  AuthedSettingsPrivacyIndexRoute: AuthedSettingsPrivacyIndexRoute,
  AuthedSettingsSessionsIndexRoute: AuthedSettingsSessionsIndexRoute,
  AuthedEventsIdEditIndexRoute: AuthedEventsIdEditIndexRoute,
  AuthedModerationAutoHideNoticeHoldIdIndexRoute:
    AuthedModerationAutoHideNoticeHoldIdIndexRoute,
  AuthedModerationContestContestationIdIndexRoute:
    AuthedModerationContestContestationIdIndexRoute,
  AuthedSettingsPrivacyBlockedIndexRoute:
    AuthedSettingsPrivacyBlockedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PublicLandingRouteChildren {
  PublicLandingGetStartedRoute: typeof PublicLandingGetStartedRoute
  PublicLandingJoinUsRoute: typeof PublicLandingJoinUsRoute
  PublicLandingSignInRoute: typeof PublicLandingSignInRoute
}

const PublicLandingRouteChildren: PublicLandingRouteChildren = {
  PublicLandingGetStartedRoute: PublicLandingGetStartedRoute,
  PublicLandingJoinUsRoute: PublicLandingJoinUsRoute,
  PublicLandingSignInRoute: PublicLandingSignInRoute,
}

const PublicLandingRouteWithChildren = PublicLandingRoute._addFileChildren(
  PublicLandingRouteChildren,
)

interface PublicRouteChildren {
  PublicLandingRoute: typeof PublicLandingRouteWithChildren
  PublicJoinACircleRoute: typeof PublicJoinACircleRoute
  PublicStartACircleRoute: typeof PublicStartACircleRoute
  PublicJoinANetworkSlugRoute: typeof PublicJoinANetworkSlugRoute
  PublicJoinSlugRoute: typeof PublicJoinSlugRoute
  PublicCirclesIndexRoute: typeof PublicCirclesIndexRoute
  PublicJoinANetworkIndexRoute: typeof PublicJoinANetworkIndexRoute
  PublicJoinIndexRoute: typeof PublicJoinIndexRoute
  PublicNetworksIndexRoute: typeof PublicNetworksIndexRoute
  PublicResourcesIndexRoute: typeof PublicResourcesIndexRoute
  PublicCirclesIdIndexRoute: typeof PublicCirclesIdIndexRoute
  PublicNetworksIdIndexRoute: typeof PublicNetworksIdIndexRoute
  PublicResourcesIdIndexRoute: typeof PublicResourcesIdIndexRoute
  PublicResourcesLearningTracksTrackIdIndexRoute: typeof PublicResourcesLearningTracksTrackIdIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLandingRoute: PublicLandingRouteWithChildren,
  PublicJoinACircleRoute: PublicJoinACircleRoute,
  PublicStartACircleRoute: PublicStartACircleRoute,
  PublicJoinANetworkSlugRoute: PublicJoinANetworkSlugRoute,
  PublicJoinSlugRoute: PublicJoinSlugRoute,
  PublicCirclesIndexRoute: PublicCirclesIndexRoute,
  PublicJoinANetworkIndexRoute: PublicJoinANetworkIndexRoute,
  PublicJoinIndexRoute: PublicJoinIndexRoute,
  PublicNetworksIndexRoute: PublicNetworksIndexRoute,
  PublicResourcesIndexRoute: PublicResourcesIndexRoute,
  PublicCirclesIdIndexRoute: PublicCirclesIdIndexRoute,
  PublicNetworksIdIndexRoute: PublicNetworksIdIndexRoute,
  PublicResourcesIdIndexRoute: PublicResourcesIdIndexRoute,
  PublicResourcesLearningTracksTrackIdIndexRoute:
    PublicResourcesLearningTracksTrackIdIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AuthRouteChildren {
  AuthFinishingRoute: typeof AuthFinishingRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthPasswordResetRoute: typeof AuthPasswordResetRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthFinishingRoute: AuthFinishingRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthPasswordResetRoute: AuthPasswordResetRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface OnboardingRouteChildren {
  OnboardingBuildSkillsRoute: typeof OnboardingBuildSkillsRoute
  OnboardingCirclesRoute: typeof OnboardingCirclesRoute
  OnboardingCompleteRoute: typeof OnboardingCompleteRoute
  OnboardingGetInvolvedRoute: typeof OnboardingGetInvolvedRoute
  OnboardingProfileRoute: typeof OnboardingProfileRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
  OnboardingClCompleteRoute: typeof OnboardingClCompleteRoute
  OnboardingClCreateCircleRoute: typeof OnboardingClCreateCircleRoute
  OnboardingClWelcomeRoute: typeof OnboardingClWelcomeRoute
  OnboardingCmBuildSkillsRoute: typeof OnboardingCmBuildSkillsRoute
  OnboardingCmCompleteRoute: typeof OnboardingCmCompleteRoute
  OnboardingCmConnectRoute: typeof OnboardingCmConnectRoute
  OnboardingCmFindCircleRoute: typeof OnboardingCmFindCircleRoute
  OnboardingCmWelcomeRoute: typeof OnboardingCmWelcomeRoute
  OnboardingJAboutRoute: typeof OnboardingJAboutRoute
  OnboardingJCircleRoute: typeof OnboardingJCircleRoute
  OnboardingJYoureInRoute: typeof OnboardingJYoureInRoute
  OnboardingNlAccessNetworkRoute: typeof OnboardingNlAccessNetworkRoute
  OnboardingNlCompleteRoute: typeof OnboardingNlCompleteRoute
  OnboardingNlHubRoute: typeof OnboardingNlHubRoute
  OnboardingNlManageNetworkRoute: typeof OnboardingNlManageNetworkRoute
  OnboardingNlNetworkPageRoute: typeof OnboardingNlNetworkPageRoute
  OnboardingNlWelcomeRoute: typeof OnboardingNlWelcomeRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingBuildSkillsRoute: OnboardingBuildSkillsRoute,
  OnboardingCirclesRoute: OnboardingCirclesRoute,
  OnboardingCompleteRoute: OnboardingCompleteRoute,
  OnboardingGetInvolvedRoute: OnboardingGetInvolvedRoute,
  OnboardingProfileRoute: OnboardingProfileRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
  OnboardingClCompleteRoute: OnboardingClCompleteRoute,
  OnboardingClCreateCircleRoute: OnboardingClCreateCircleRoute,
  OnboardingClWelcomeRoute: OnboardingClWelcomeRoute,
  OnboardingCmBuildSkillsRoute: OnboardingCmBuildSkillsRoute,
  OnboardingCmCompleteRoute: OnboardingCmCompleteRoute,
  OnboardingCmConnectRoute: OnboardingCmConnectRoute,
  OnboardingCmFindCircleRoute: OnboardingCmFindCircleRoute,
  OnboardingCmWelcomeRoute: OnboardingCmWelcomeRoute,
  OnboardingJAboutRoute: OnboardingJAboutRoute,
  OnboardingJCircleRoute: OnboardingJCircleRoute,
  OnboardingJYoureInRoute: OnboardingJYoureInRoute,
  OnboardingNlAccessNetworkRoute: OnboardingNlAccessNetworkRoute,
  OnboardingNlCompleteRoute: OnboardingNlCompleteRoute,
  OnboardingNlHubRoute: OnboardingNlHubRoute,
  OnboardingNlManageNetworkRoute: OnboardingNlManageNetworkRoute,
  OnboardingNlNetworkPageRoute: OnboardingNlNetworkPageRoute,
  OnboardingNlWelcomeRoute: OnboardingNlWelcomeRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  CommunityGuidelinesRoute: CommunityGuidelinesRoute,
  HelpRoute: HelpRoute,
  NotFoundRoute: NotFoundRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  InvitesTokenRoute: InvitesTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
